/*!
 * dasoertliche-javascript-library-7.27
 * 
 * Copyright (C) 2008-2026 TENSQUARE GmbH. All rights reserved.
 * https://www.tensquare.de
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE GmbH.
 */
(function($) {
    var ieScriptVersion = eval("/*@cc_on @_jscript_version||@*/0"), isIE = !!ieScriptVersion, acMoreClass = "ac_more";
    $.fn.extend({
        autocomplete: function(urlOrData, options) {
            var isUrl = typeof urlOrData === "string";
            options = $.extend({}, $.Autocompleter.defaults, {
                reloadData: typeof options.onChangeTerm === "function",
                moreParams: $v$.tools.getAsObject(options.moreParams),
                url: isUrl ? urlOrData : null,
                data: isUrl ? null : urlOrData,
                delay: isUrl ? $.Autocompleter.defaults.delay : 10,
                max: options && !options.scroll ? 10 : 150
            }, options);
            options.highlight = options.highlight || function(value) {
                return value;
            };
            options.formatMatch = options.formatMatch || options.formatItem;
            return this.each(function() {
                new $.Autocompleter(this, options);
            });
        },
        hideResultsNow: function() {
            return this.trigger("hideResultsNow");
        },
        getContainer: function() {
            return this.triggerHandler("getContainer");
        },
        getInput: function() {
            return this.triggerHandler("getInput");
        },
        generateCacheKey: function(p, obj) {
            return this.trigger("generateCacheKey", [ p, obj ]);
        },
        result: function(handler) {
            return this.on("result", handler);
        },
        search: function(handler) {
            return this.trigger("search", [ handler ]);
        },
        flushCache: function() {
            return this.trigger("flushCache");
        },
        setOptions: function(options) {
            return this.trigger("setOptions", [ options ]);
        },
        setACData: function(data, term) {
            return this.trigger("setACData", [ data, term ]);
        },
        unautocomplete: function() {
            return this.trigger("unautocomplete");
        }
    });
    $.Autocompleter = function(input, options) {
        var KEY = {
            UP: 38,
            DOWN: 40,
            DEL: 46,
            TAB: 9,
            RETURN: 13,
            ESC: 27,
            COMMA: 188,
            PAGEUP: 33,
            PAGEDOWN: 34,
            BACKSPACE: 8
        }, $input = $(input).attr("autocomplete", "off").addClass(options.inputClass), timeout, previousValue = "", cache = $.Autocompleter.Cache(options), hasFocus = 0, lastKeyPressCode, config = {
            mouseDownOnSelect: false
        }, select = $.Autocompleter.Select(options, input, selectCurrent, config), blockSubmit, isOpera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
        isOpera && $(input.form).on("submit.autocomplete", function() {
            if (blockSubmit) {
                blockSubmit = false;
                return false;
            }
        });
        $input.on((isOpera ? "keypress" : "keydown") + ".autocomplete", function(event) {
            hasFocus = 1;
            lastKeyPressCode = event.keyCode;
            switch (event.keyCode) {
              case KEY.UP:
                event.preventDefault();
                if (select.visible()) {
                    select.prev();
                } else {
                    onChange(0, true);
                }
                break;

              case KEY.DOWN:
                event.preventDefault();
                if (select.visible()) {
                    select.next();
                } else {
                    onChange(0, true);
                }
                break;

              case KEY.PAGEUP:
                event.preventDefault();
                if (select.visible()) {
                    select.pageUp();
                } else {
                    onChange(0, true);
                }
                break;

              case KEY.PAGEDOWN:
                event.preventDefault();
                if (select.visible()) {
                    select.pageDown();
                } else {
                    onChange(0, true);
                }
                break;

              case options.multiple && options.multipleSeparator.trim() === "," && KEY.COMMA:
              case KEY.TAB:
              case KEY.RETURN:
                if (selectCurrent()) {
                    event.preventDefault();
                    blockSubmit = true;
                    return false;
                }
                hideResultsNow();
                break;

              case KEY.ESC:
                select.hide();
                break;

              default:
                clearTimeout(timeout);
                timeout = setTimeout(onChange, options.delay);
                break;
            }
        }).on("focus", function() {
            hasFocus++;
        }).on("generateCacheKey", function() {
            var q = arguments[1], obj = arguments[2];
            obj.key = generateCacheKey(q);
        }).on("hideResultsNow", function() {
            if (hasFocus > 0) return;
            hideResultsNow();
        }).on("getContainer", function() {
            return select.getContainer();
        }).on("getInput", function() {
            return $input;
        }).on("blur", function() {
            hasFocus = 0;
            if (!config.mouseDownOnSelect) {
                hideResults();
            }
        }).on("click", function() {
            if (hasFocus++ > 1 && !select.visible()) {
                onChange(0, true);
            }
        }).on("search", function() {
            var fn = arguments.length > 1 ? arguments[1] : null;
            function findValueCallback(q, data) {
                var result;
                if (data && data.length) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].result.toLowerCase() === q.toLowerCase()) {
                            result = data[i];
                            break;
                        }
                    }
                }
                if (typeof fn === "function") fn(result); else $input.trigger("result", result && [ result.data, result.value ]);
            }
            $.each(trimWords($input.val()), function(i, value) {
                request(value, findValueCallback, findValueCallback);
            });
        }).on("flushCache", function() {
            cache.flush();
        }).on("setACData", function() {
            var data = arguments[1], term = arguments[2], parsed = options.parse && options.parse(data) || parse(data);
            parsed.useMore = data.useMore;
            cache.add(generateCacheKey(term), parsed);
            receiveData(term, parsed);
        }).on("setOptions", function() {
            $.extend(options, arguments[1]);
            if ("data" in arguments[1]) cache.populate();
        }).on("unautocomplete", function() {
            select.off();
            $input.off();
            $(input.form).off("autocomplete");
        });
        function setSingleSelection(form, name, value) {
            var fn, input, inputExists;
            if (options.onChangeValue && typeof options.onChangeValue === "function") {
                fn = options.onChangeValue.getBinding($input);
                fn(name, value);
            }
            input = form.find("input[name='" + name + "']");
            inputExists = input.length > 0;
            if (!inputExists) {
                input = $v$.tools.createEl("input");
                input.type = "hidden";
                input.name = name;
                if (value) input.value = value;
                form.prepend(input);
            }
            for (var i = 0; i < input.length; i++) {
                if (input[i].type !== "hidden" && !value) continue;
                $(input[i]).val(value);
                if (input[i].type !== "hidden" && value) {
                    if (typeof options.onFillField === "function") options.onFillField(input);
                }
            }
        }
        function clearSelection(form) {
            for (var i = 0; i < options.addParams.length; i++) {
                setSingleSelection(form, options.addParams[i], "");
            }
            for (var param in options.selectParams) {
                if (options.selectParams.hasOwnProperty(param)) {
                    setSingleSelection(form, param, "");
                }
            }
        }
        function setSelection(selection, form) {
            for (var i = 0; i < options.addParams.length; i++) {
                setSingleSelection(form, options.addParams[i], selection.data[i + 1]);
            }
            for (var param in options.selectParams) {
                if (options.selectParams.hasOwnProperty(param)) {
                    setSingleSelection(form, param, options.selectParams[param]);
                }
            }
        }
        function selectCurrent() {
            var selectedItem = select.getSelected(), selected = select.selected(), v, words, seperator, cursorAt, wordAt, progress;
            if (!selected) {
                if (lastKeyPressCode !== KEY.RETURN) {
                    clearSelection($(input.form));
                }
                if (lastKeyPressCode === KEY.RETURN && selectedItem && selectedItem.length && selectedItem.hasClass(acMoreClass)) {
                    window.location.href = select.createMoreURL();
                    return true;
                }
                return false;
            }
            v = selected.result;
            previousValue = v;
            if (options.multiple) {
                words = trimWords($input.val());
                if (words.length > 1) {
                    seperator = options.multipleSeparator.length;
                    cursorAt = $(input).selection().start;
                    progress = 0;
                    $.each(words, function(i, word) {
                        progress += word.length;
                        if (cursorAt <= progress) {
                            wordAt = i;
                            return false;
                        }
                        progress += seperator;
                    });
                    if (typeof wordAt !== "undefined") {
                        words[wordAt] = v;
                    }
                    v = words.join(options.multipleSeparator);
                }
                v += options.multipleSeparator;
            }
            $input.val(v);
            setSelection(selected, $(input.form));
            hideResultsNow();
            $input.trigger("result", [ selected.data, selected.value ]);
            if (options.autoSubmit) {
                $(input.form).submit();
            }
            return true;
        }
        function onChange(crap, skipPrevCheck) {
            var currentValue = $input.val(), items;
            if (!skipPrevCheck && currentValue === previousValue) return;
            if (lastKeyPressCode !== KEY.UP && lastKeyPressCode !== 37 && lastKeyPressCode !== 39 && lastKeyPressCode !== KEY.DOWN && lastKeyPressCode !== KEY.ESC && lastKeyPressCode !== KEY.PAGEUP && lastKeyPressCode !== KEY.PAGEDOWN) clearSelection($(input.form));
            previousValue = currentValue;
            currentValue = lastWord(currentValue);
            currentValue = currentValue.trim();
            while (currentValue.indexOf("  ") > -1) {
                currentValue = currentValue.replace("  ", " ");
            }
            if (currentValue.length >= options.minChars) {
                $input.addClass(options.loadingClass);
                if (!options.matchCase) {
                    currentValue = currentValue.toLowerCase();
                }
                request(currentValue, receiveData, hideResultsNow);
                if (options.autoSelect && select.getList()) {
                    items = select.getList().children("li");
                    for (var i = 0; i < items.length; i++) {
                        if ($(items[i]).text().toLowerCase() === currentValue.toLowerCase()) {
                            setSelection(select.find(items[i]), $(input.form));
                            break;
                        }
                    }
                }
            } else {
                stopLoading();
                select.hide();
            }
        }
        function trimWords(value) {
            if (!value) return [ "" ];
            if (!options.multiple) return [ value.trim() ];
            return $.map(value.split(options.multipleSeparator), function(word) {
                return value.trim().length ? word.trim() : null;
            });
        }
        function lastWord(value) {
            if (!options.multiple) {
                return value;
            }
            var words = trimWords(value), cursorAt;
            if (words.length === 1) {
                return words[0];
            }
            cursorAt = $(input).selection().start;
            if (cursorAt === value.length) {
                words = trimWords(value);
            } else {
                words = trimWords(value.replace(value.substring(cursorAt), ""));
            }
            return words[words.length - 1];
        }
        function autoFill(q, sValue) {
            if (options.autoFill && lastWord($input.val()).toLowerCase() === q.toLowerCase() && lastKeyPressCode !== KEY.BACKSPACE) {
                $input.val($input.val() + sValue.substring(lastWord(previousValue).length));
                $(input).selection(previousValue.length, previousValue.length + sValue.length);
            }
        }
        function hideResults() {
            clearTimeout(timeout);
            timeout = setTimeout(hideResultsNow, 200);
        }
        function hideResultsNow() {
            var wasVisible = select.visible();
            select.hide();
            clearTimeout(timeout);
            stopLoading();
            if (options.mustMatch) {
                $input.search(function(result) {
                    if (!result) {
                        if (options.multiple) {
                            var words = trimWords($input.val()).slice(0, -1);
                            $input.val(words.join(options.multipleSeparator) + (words.length ? options.multipleSeparator : ""));
                        } else {
                            $input.val("");
                            $input.trigger("result", null);
                        }
                    }
                });
            }
        }
        function receiveData(q, data) {
            if (data && data.length && hasFocus) {
                stopLoading();
                select.display(data, q);
                autoFill(q, data[0].value);
                select.show();
            } else {
                hideResultsNow();
            }
        }
        function generateCacheKey(q) {
            var keyPrefix = $(input).data(options.keyPrefixDataName);
            if (!keyPrefix || keyPrefix === "") keyPrefix = "~~~~EMPTY~~~~";
            return keyPrefix + q;
        }
        function request(term, success, failure) {
            if (!options.matchCase) {
                term = term.toLowerCase();
            }
            var data = cache.load(generateCacheKey(term)), extraParams, fn;
            if (data && data.length) {
                success(term, data);
            } else if (typeof options.url === "string" && options.url.length > 0) {
                extraParams = {
                    timestamp: +new Date()
                };
                $.each(options.extraParams, function(key, param) {
                    extraParams[key] = typeof param === "function" ? param() : param;
                });
                $.ajax({
                    mode: "abort",
                    port: "autocomplete" + input.name,
                    dataType: options.dataType,
                    url: options.url,
                    data: $.extend({
                        q: lastWord(term),
                        limit: options.max
                    }, extraParams),
                    done: function(data) {
                        var parsed = options.parse && options.parse(data) || parse(data);
                        cache.add(term, parsed);
                        success(term, parsed);
                    }
                });
            } else if (options.reloadData) {
                fn = options.onChangeTerm.getBinding($input, term);
                if (typeof fn === "function") {
                    fn.call(this);
                }
            } else {
                select.emptyList();
                failure(term);
            }
        }
        function parse(data) {
            var parsed = [], row;
            for (var i = 0; i < data.length; i++) {
                row = data[i];
                if (row) {
                    parsed[parsed.length] = {
                        data: row,
                        value: row[0],
                        result: typeof options.formatResult === "function" && options.formatResult(row, row[0]) || row[0]
                    };
                }
            }
            return parsed;
        }
        function stopLoading() {
            $input.removeClass(options.loadingClass);
        }
    };
    $.Autocompleter.defaults = {
        onFillField: null,
        onChangeTerm: null,
        onChangeValue: null,
        onBeforeShow: null,
        moreURL: "",
        moreParams: {},
        selectParams: {},
        moreText: "",
        moreValueParam: "",
        addParams: [],
        autoSubmit: true,
        autoSelect: false,
        keyPrefixDataName: "ac_keyprefix",
        leftDelta: 0,
        inputClass: "ac_input",
        resultsClass: "ac_results",
        loadingClass: "ac_loading",
        minChars: 1,
        delay: 400,
        matchCase: false,
        matchSubset: true,
        matchContains: false,
        cacheLength: 10,
        max: 100,
        mustMatch: false,
        extraParams: {},
        selectFirst: true,
        formatItem: function(row) {
            return row[0];
        },
        formatMatch: null,
        autoFill: false,
        width: 0,
        multiple: false,
        multipleSeparator: ", ",
        highlight: function(value, term) {
            return value.replace(new RegExp("^(?![^&;]+;)(?!<[^<>]*)(" + term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "i"), "<strong>$1</strong>");
        },
        scroll: true,
        scrollHeight: 180
    };
    $.Autocompleter.Cache = function(options) {
        var data = {}, length = 0;
        function matchSubset(s, sub) {
            if (!options.matchCase) {
                s = s.toLowerCase();
            }
            var i = s.indexOf(sub);
            if (options.matchContains === "word") {
                i = s.toLowerCase().search("\\b" + sub.toLowerCase());
            }
            if (i === -1) {
                return false;
            }
            return i === 0 || options.matchContains;
        }
        function add(q, value) {
            if (length > options.cacheLength) {
                flush();
            }
            if (!data[q]) {
                length++;
            }
            data[q] = value;
        }
        function populate() {
            if (!options.data) return false;
            var stMatchSets = {}, nullData = 0, rawValue, value, firstChar, row;
            if (!options.url) options.cacheLength = 1;
            stMatchSets[""] = [];
            for (var i = 0, ol = options.data.length; i < ol; i++) {
                rawValue = options.data[i];
                rawValue = typeof rawValue === "string" ? [ rawValue ] : rawValue;
                value = options.formatMatch(rawValue, i + 1, options.data.length);
                if (value === false) continue;
                firstChar = value.charAt(0).toLowerCase();
                if (!stMatchSets[firstChar]) stMatchSets[firstChar] = [];
                row = {
                    value: value,
                    data: rawValue,
                    result: typeof options.formatResult === "function" && options.formatResult(rawValue) || value
                };
                stMatchSets[firstChar].push(row);
                if (nullData++ < options.max) {
                    stMatchSets[""].push(row);
                }
            }
            $.each(stMatchSets, function(i, value) {
                options.cacheLength++;
                add(i, value);
            });
        }
        setTimeout(populate, 25);
        function flush() {
            data = {};
            length = 0;
        }
        return {
            flush: flush,
            add: add,
            populate: populate,
            load: function(q) {
                if (!options.cacheLength || !length) return null;
                var c, csub, k;
                if (!options.url && options.matchContains) {
                    csub = [];
                    for (k in data) {
                        if (k.length > 0) {
                            c = data[k];
                            $.each(c, function(i, x) {
                                if (matchSubset(x.value, q)) {
                                    csub.push(x);
                                }
                            });
                        }
                    }
                    return csub;
                } else if (data[q]) {
                    return data[q];
                } else if (options.matchSubset) {
                    for (var i = q.length - 1; i >= options.minChars; i--) {
                        c = data[q.substr(0, i)];
                        if (c) {
                            csub = [];
                            $.each(c, function(i, x) {
                                if (matchSubset(x.value, q)) {
                                    csub[csub.length] = x;
                                }
                            });
                            return csub;
                        }
                    }
                }
                return null;
            }
        };
    };
    $.Autocompleter.Select = function(options, input, select, config) {
        var CLASSES = {
            ACTIVE: "ac_over",
            MOUSEOVER: "ac_mouseover"
        }, listItems, active = -1, data, term = "", needsInit = true, element, list;
        function init() {
            if (!needsInit) return;
            element = $("<div/>").hide().addClass(options.resultsClass).css("position", "absolute").appendTo(document.body);
            list = $("<ul/>").appendTo(element).on("mouseover", function(event) {
                if (target(event).nodeName && target(event).nodeName.toUpperCase() === "LI") {
                    active = $("li", list).removeClass(CLASSES.MOUSEOVER).index(target(event));
                    $(target(event)).addClass(CLASSES.MOUSEOVER);
                }
            }).on("click", function(event) {
                var moreEvent, value;
                if ($(target(event)).hasClass(acMoreClass)) {
                    if (options.moreEvent !== null) {
                        moreEvent = options.moreEvent;
                        value = $(input).val();
                        return moreEvent(value);
                    }
                    window.location.href = createMoreURL();
                    return true;
                }
                $(target(event)).addClass(CLASSES.ACTIVE);
                select();
                input.focus();
                return false;
            }).on("mousedown", function() {
                config.mouseDownOnSelect = true;
            }).on("mouseup", function() {
                config.mouseDownOnSelect = false;
            });
            if (options.width > 0) element.css("width", options.width);
            needsInit = false;
        }
        function target(event) {
            var element = event.target;
            while (element && element.tagName !== "LI") {
                element = element.parentNode;
            }
            if (!element) {
                return [];
            }
            return element;
        }
        function moveSelect(step) {
            listItems.slice(active, active + 1).removeClass(CLASSES.ACTIVE);
            movePosition(step);
            var activeItem = listItems.slice(active, active + 1).addClass(CLASSES.ACTIVE), offset;
            if (options.scroll) {
                offset = 0;
                listItems.slice(0, active).each(function() {
                    offset += this.offsetHeight;
                });
                if (offset + activeItem[0].offsetHeight - list.scrollTop() > list[0].clientHeight) {
                    list.scrollTop(offset + activeItem[0].offsetHeight - list.innerHeight());
                } else if (offset < list.scrollTop()) {
                    list.scrollTop(offset);
                }
            }
        }
        function movePosition(step) {
            active += step;
            if (active < 0) {
                active = listItems.length - 1;
            } else if (active >= listItems.length) {
                active = 0;
            }
        }
        function limitNumberOfItems(available) {
            return options.max && options.max < available ? options.max : available;
        }
        function getValues() {
            var result = [], form, $inputs;
            form = $(input).parents("form:first");
            $inputs = $("input, textarea, select", form);
            $inputs.each(function(i, el) {
                if (el.type !== "checkbox" || $(el).is(":checked")) {
                    result[[ el.name ]] = $(el).val();
                }
            });
            return result;
        }
        function createMoreURL() {
            var params = $.extend({}, getValues(), options.moreParams), paramCodec = new $oe$.util.QueryStringCodec();
            params[options.moreValueParam] = $(input).val();
            return options.moreURL + "?" + paramCodec.encode(params, false);
        }
        function fillList() {
            list.empty();
            var max = limitNumberOfItems(data.length), i, li, itemData, formatted, className;
            if (!data.useMore) {
                max = 1e3;
            }
            for (i = 0; i < max; i++) {
                if (!data[i]) {
                    continue;
                }
                itemData = data[i].data;
                formatted = options.formatItem(itemData, i + 1, max, data[i].value, term);
                if (formatted === false) {
                    continue;
                }
                if (itemData && (itemData.length >= 8 && itemData[7] === true)) {
                    li = $("<li/>").html(options.highlight(formatted, term)).addClass(i % 2 === 0 ? "ac_even_bb" : "ac_odd_bb").appendTo(list)[0];
                } else {
                    li = $("<li/>").html(options.highlight(formatted, term)).addClass(i % 2 === 0 ? "ac_even" : "ac_odd").appendTo(list)[0];
                }
                $.data(li, "ac_data", data[i]);
                if (i === max - 1 && max < data.length && data.useMore) {
                    i++;
                    className = i % 2 === 0 ? "ac_even " + acMoreClass : "ac_odd " + acMoreClass;
                    formatted = options.formatItem([ options.moreText ], i + 1, max, options.moreText, term);
                    li = $("<li/>").html(formatted).addClass(className).appendTo(list)[0];
                }
            }
            listItems = list.find("li");
            if (options.selectFirst) {
                listItems.slice(0, 1).addClass(CLASSES.ACTIVE);
                active = 0;
            }
            if ($.fn.bgiframe) list.bgiframe();
        }
        return {
            getList: function() {
                return list;
            },
            getContainer: function() {
                return element;
            },
            find: function(item) {
                return $.data(item, "ac_data");
            },
            createMoreURL: createMoreURL,
            display: function(d, q) {
                init();
                data = d;
                term = q;
                fillList();
            },
            next: function() {
                moveSelect(1);
            },
            prev: function() {
                moveSelect(-1);
            },
            pageUp: function() {
                if (active !== 0 && active - 8 < 0) {
                    moveSelect(-active);
                } else {
                    moveSelect(-8);
                }
            },
            pageDown: function() {
                if (active !== listItems.length - 1 && active + 8 > listItems.length) {
                    moveSelect(listItems.length - 1 - active);
                } else {
                    moveSelect(8);
                }
            },
            hide: function() {
                element && element.hide();
                listItems && listItems.removeClass(CLASSES.ACTIVE);
                active = -1;
            },
            visible: function() {
                return element && element.is(":visible");
            },
            current: function() {
                return this.visible() && (listItems.filter("." + CLASSES.ACTIVE)[0] || options.selectFirst && listItems[0]);
            },
            show: function() {
                var offset = $(input).offset(), padding, fn, currentValue, width, listHeight, scrollbarsVisible;
                padding = parseInt($(input).css("padding-left")) + parseInt($(input).css("padding-right")) - 1;
                if (options.onBeforeShow && typeof options.onBeforeShow === "function") {
                    fn = options.onBeforeShow.getBinding($(input));
                    currentValue = $(input).val();
                    if (!options.matchCase) {
                        currentValue = currentValue.toLowerCase();
                    }
                    width = typeof options.width === "string" || options.width > 0 ? options.width : $(input).width() + padding;
                    fn($(input), options, currentValue, width);
                }
                element.css({
                    width: typeof options.width === "string" || options.width > 0 ? options.width : $(input).width() + padding,
                    top: offset.top + input.offsetHeight,
                    left: offset.left + options.leftDelta
                }).show();
                if (options.scroll) {
                    list.scrollTop(0);
                    list.css({
                        maxHeight: options.scrollHeight,
                        overflow: "auto"
                    });
                    if (isIE && typeof document.body.style.maxHeight === "undefined") {
                        listHeight = 0;
                        listItems.each(function() {
                            listHeight += this.offsetHeight;
                        });
                        scrollbarsVisible = listHeight > options.scrollHeight;
                        list.css("height", scrollbarsVisible ? options.scrollHeight : listHeight);
                        if (!scrollbarsVisible) {
                            listItems.width(list.width() - parseInt(listItems.css("padding-left")) - parseInt(listItems.css("padding-right")));
                        }
                    }
                }
            },
            getSelected: function() {
                return listItems && listItems.filter("." + CLASSES.ACTIVE);
            },
            selected: function() {
                var selected = listItems && listItems.filter("." + CLASSES.ACTIVE).removeClass(CLASSES.ACTIVE);
                return selected && selected.length && $.data(selected[0], "ac_data");
            },
            emptyList: function() {
                list && list.empty();
            },
            unbind: function() {
                element && element.remove();
            }
        };
    };
    $.fn.selection = function(start, end) {
        if (start !== undefined) {
            return this.each(function() {
                if (this.createTextRange) {
                    var selRange = this.createTextRange();
                    if (end === undefined || start === end) {
                        selRange.move("character", start);
                        selRange.select();
                    } else {
                        selRange.collapse(true);
                        selRange.moveStart("character", start);
                        selRange.moveEnd("character", end);
                        selRange.select();
                    }
                } else if (this.setSelectionRange) {} else if (this.selectionStart) {
                    this.selectionStart = start;
                    this.selectionEnd = end;
                }
            });
        }
        var field = this[0], range, caretAt, orig, teststring, textLength;
        if (field.createTextRange) {
            range = document.selection.createRange();
            orig = field.value;
            teststring = "<->";
            textLength = range.text.length;
            range.text = teststring;
            caretAt = field.value.indexOf(teststring);
            field.value = orig;
            this.selection(caretAt, caretAt + textLength);
            return {
                start: caretAt,
                end: caretAt + textLength
            };
        } else if (field.selectionStart !== undefined) {
            return {
                start: field.selectionStart,
                end: field.selectionEnd
            };
        }
    };
})(jQuery);

/*! rangeslider.js - v2.3.0 | (c) 2016 @andreruffert | MIT license | https://github.com/andreruffert/rangeslider.js */
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) {
        define([ "jquery" ], factory);
    } else if (typeof exports === "object") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(function($) {
    "use strict";
    Number.isNaN = Number.isNaN || function(value) {
        return typeof value === "number" && value !== value;
    };
    function supportsRange() {
        var input = document.createElement("input");
        input.setAttribute("type", "range");
        return input.type !== "text";
    }
    var pluginName = "rangeslider", pluginIdentifier = 0, hasInputRangeSupport = supportsRange(), defaults = {
        polyfill: true,
        orientation: "horizontal",
        rangeClass: "rangeslider",
        disabledClass: "rangeslider--disabled",
        activeClass: "rangeslider--active",
        horizontalClass: "rangeslider--horizontal",
        verticalClass: "rangeslider--vertical",
        fillClass: "rangeslider__fill",
        handleClass: "rangeslider__handle",
        startEvent: [ "mousedown", "touchstart", "pointerdown" ],
        moveEvent: [ "mousemove", "touchmove", "pointermove" ],
        endEvent: [ "mouseup", "touchend", "pointerup" ]
    }, constants = {
        orientation: {
            horizontal: {
                dimension: "width",
                direction: "left",
                directionStyle: "left",
                coordinate: "x"
            },
            vertical: {
                dimension: "height",
                direction: "top",
                directionStyle: "bottom",
                coordinate: "y"
            }
        }
    };
    function delay(fn, wait) {
        var args = Array.prototype.slice.call(arguments, 2);
        return setTimeout(function() {
            return fn.apply(null, args);
        }, wait);
    }
    function debounce(fn, debounceDuration) {
        debounceDuration = debounceDuration || 100;
        return function() {
            if (!fn.debouncing) {
                var args = Array.prototype.slice.apply(arguments);
                fn.lastReturnVal = fn.apply(window, args);
                fn.debouncing = true;
            }
            clearTimeout(fn.debounceTimeout);
            fn.debounceTimeout = setTimeout(function() {
                fn.debouncing = false;
            }, debounceDuration);
            return fn.lastReturnVal;
        };
    }
    function isHidden(element) {
        return element && (element.offsetWidth === 0 || element.offsetHeight === 0 || element.open === false);
    }
    function getHiddenParentNodes(element) {
        var parents = [], node = element.parentNode;
        while (isHidden(node)) {
            parents.push(node);
            node = node.parentNode;
        }
        return parents;
    }
    function getDimension(element, key) {
        var hiddenParentNodes = getHiddenParentNodes(element), hiddenParentNodesLength = hiddenParentNodes.length, inlineStyle = [], dimension = element[key];
        function toggleOpenProperty(element) {
            if (typeof element.open !== "undefined") {
                element.open = element.open ? false : true;
            }
        }
        if (hiddenParentNodesLength) {
            for (var i = 0; i < hiddenParentNodesLength; i++) {
                inlineStyle[i] = hiddenParentNodes[i].style.cssText;
                if (hiddenParentNodes[i].style.setProperty) {
                    hiddenParentNodes[i].style.setProperty("display", "block", "important");
                } else {
                    hiddenParentNodes[i].style.cssText += ";display: block !important";
                }
                hiddenParentNodes[i].style.height = "0";
                hiddenParentNodes[i].style.overflow = "hidden";
                hiddenParentNodes[i].style.visibility = "hidden";
                toggleOpenProperty(hiddenParentNodes[i]);
            }
            dimension = element[key];
            for (var j = 0; j < hiddenParentNodesLength; j++) {
                hiddenParentNodes[j].style.cssText = inlineStyle[j];
                toggleOpenProperty(hiddenParentNodes[j]);
            }
        }
        return dimension;
    }
    function tryParseFloat(str, defaultValue) {
        var value = parseFloat(str);
        return Number.isNaN(value) ? defaultValue : value;
    }
    function ucfirst(str) {
        return str.charAt(0).toUpperCase() + str.substr(1);
    }
    function Plugin(element, options) {
        this.$window = $(window);
        this.$document = $(document);
        this.$element = $(element);
        this.options = $.extend({}, defaults, options);
        this.polyfill = this.options.polyfill;
        this.orientation = this.$element[0].getAttribute("data-orientation") || this.options.orientation;
        this.onInit = this.options.onInit;
        this.onSlide = this.options.onSlide;
        this.onSlideEnd = this.options.onSlideEnd;
        this.DIMENSION = constants.orientation[this.orientation].dimension;
        this.DIRECTION = constants.orientation[this.orientation].direction;
        this.DIRECTION_STYLE = constants.orientation[this.orientation].directionStyle;
        this.COORDINATE = constants.orientation[this.orientation].coordinate;
        if (this.polyfill) {
            if (hasInputRangeSupport) {
                return false;
            }
        }
        this.identifier = "js-" + pluginName + "-" + pluginIdentifier++;
        this.startEvent = this.options.startEvent.join("." + this.identifier + " ") + "." + this.identifier;
        this.moveEvent = this.options.moveEvent.join("." + this.identifier + " ") + "." + this.identifier;
        this.endEvent = this.options.endEvent.join("." + this.identifier + " ") + "." + this.identifier;
        this.toFixed = (this.step + "").replace(".", "").length - 1;
        this.$fill = $('<div class="' + this.options.fillClass + '" />');
        this.$handle = $('<div class="' + this.options.handleClass + '" />');
        this.$range = $('<div class="' + this.options.rangeClass + " " + this.options[this.orientation + "Class"] + '" id="' + this.identifier + '" />').insertAfter(this.$element).prepend(this.$fill, this.$handle);
        this.$element.css({
            position: "absolute",
            width: "1px",
            height: "1px",
            overflow: "hidden",
            opacity: "0"
        });
        this.handleDown = $.proxy(this.handleDown, this);
        this.handleMove = $.proxy(this.handleMove, this);
        this.handleEnd = $.proxy(this.handleEnd, this);
        this.init();
        var _this = this;
        this.$window.on("resize." + this.identifier, debounce(function() {
            delay(function() {
                _this.update(false, false);
            }, 300);
        }, 20));
        this.$document.on(this.startEvent, "#" + this.identifier + ":not(." + this.options.disabledClass + ")", this.handleDown);
        this.$element.on("change." + this.identifier, function(e, data) {
            if (data && data.origin === _this.identifier) {
                return;
            }
            var value = e.target.value, pos = _this.getPositionFromValue(value);
            _this.setPosition(pos);
        });
    }
    Plugin.prototype.init = function() {
        this.update(true, false);
        if (this.onInit && typeof this.onInit === "function") {
            this.onInit();
        }
    };
    Plugin.prototype.update = function(updateAttributes, triggerSlide) {
        updateAttributes = updateAttributes || false;
        if (updateAttributes) {
            this.min = tryParseFloat(this.$element[0].getAttribute("min"), 0);
            this.max = tryParseFloat(this.$element[0].getAttribute("max"), 100);
            this.value = tryParseFloat(this.$element[0].value, Math.round(this.min + (this.max - this.min) / 2));
            this.step = tryParseFloat(this.$element[0].getAttribute("step"), 1);
        }
        this.handleDimension = getDimension(this.$handle[0], "offset" + ucfirst(this.DIMENSION));
        this.rangeDimension = getDimension(this.$range[0], "offset" + ucfirst(this.DIMENSION));
        this.maxHandlePos = this.rangeDimension - this.handleDimension;
        this.grabPos = this.handleDimension / 2;
        this.position = this.getPositionFromValue(this.value);
        if (this.$element[0].disabled) {
            this.$range.addClass(this.options.disabledClass);
        } else {
            this.$range.removeClass(this.options.disabledClass);
        }
        this.setPosition(this.position, triggerSlide);
    };
    Plugin.prototype.handleDown = function(e) {
        e.preventDefault();
        this.$document.on(this.moveEvent, this.handleMove);
        this.$document.on(this.endEvent, this.handleEnd);
        this.$range.addClass(this.options.activeClass);
        if ((" " + e.target.className + " ").replace(/[\n\t]/g, " ").indexOf(this.options.handleClass) > -1) {
            return;
        }
        var pos = this.getRelativePosition(e), rangePos = this.$range[0].getBoundingClientRect()[this.DIRECTION], handlePos = this.getPositionFromNode(this.$handle[0]) - rangePos, setPos = this.orientation === "vertical" ? this.maxHandlePos - (pos - this.grabPos) : pos - this.grabPos;
        this.setPosition(setPos);
        if (pos >= handlePos && pos < handlePos + this.handleDimension) {
            this.grabPos = pos - handlePos;
        }
    };
    Plugin.prototype.handleMove = function(e) {
        e.preventDefault();
        var pos = this.getRelativePosition(e);
        var setPos = this.orientation === "vertical" ? this.maxHandlePos - (pos - this.grabPos) : pos - this.grabPos;
        this.setPosition(setPos);
    };
    Plugin.prototype.handleEnd = function(e) {
        e.preventDefault();
        this.$document.off(this.moveEvent, this.handleMove);
        this.$document.off(this.endEvent, this.handleEnd);
        this.$range.removeClass(this.options.activeClass);
        this.$element.trigger("change", {
            origin: this.identifier
        });
        if (this.onSlideEnd && typeof this.onSlideEnd === "function") {
            this.onSlideEnd(this.position, this.value);
        }
    };
    Plugin.prototype.cap = function(pos, min, max) {
        if (pos < min) {
            return min;
        }
        if (pos > max) {
            return max;
        }
        return pos;
    };
    Plugin.prototype.setPosition = function(pos, triggerSlide) {
        var value, newPos;
        if (triggerSlide === undefined) {
            triggerSlide = true;
        }
        value = this.getValueFromPosition(this.cap(pos, 0, this.maxHandlePos));
        newPos = this.getPositionFromValue(value);
        this.$fill[0].style[this.DIMENSION] = newPos + this.grabPos + "px";
        this.$handle[0].style[this.DIRECTION_STYLE] = newPos + "px";
        this.setValue(value);
        this.position = newPos;
        this.value = value;
        if (triggerSlide && this.onSlide && typeof this.onSlide === "function") {
            this.onSlide(newPos, value);
        }
    };
    Plugin.prototype.getPositionFromNode = function(node) {
        var i = 0;
        while (node !== null) {
            i += node.offsetLeft;
            node = node.offsetParent;
        }
        return i;
    };
    Plugin.prototype.getRelativePosition = function(e) {
        var ucCoordinate = ucfirst(this.COORDINATE), rangePos = this.$range[0].getBoundingClientRect()[this.DIRECTION], pageCoordinate = 0;
        if (typeof e.originalEvent["client" + ucCoordinate] !== "undefined") {
            pageCoordinate = e.originalEvent["client" + ucCoordinate];
        } else if (e.originalEvent.touches && e.originalEvent.touches[0] && typeof e.originalEvent.touches[0]["client" + ucCoordinate] !== "undefined") {
            pageCoordinate = e.originalEvent.touches[0]["client" + ucCoordinate];
        } else if (e.currentPoint && typeof e.currentPoint[this.COORDINATE] !== "undefined") {
            pageCoordinate = e.currentPoint[this.COORDINATE];
        }
        return pageCoordinate - rangePos;
    };
    Plugin.prototype.getPositionFromValue = function(value) {
        var percentage, pos;
        percentage = (value - this.min) / (this.max - this.min);
        pos = !Number.isNaN(percentage) ? percentage * this.maxHandlePos : 0;
        return pos;
    };
    Plugin.prototype.getValueFromPosition = function(pos) {
        var percentage, value;
        percentage = pos / (this.maxHandlePos || 1);
        value = this.step * Math.round(percentage * (this.max - this.min) / this.step) + this.min;
        return Number(value.toFixed(this.toFixed));
    };
    Plugin.prototype.setValue = function(value) {
        if (value === this.value && this.$element[0].value !== "") {
            return;
        }
        this.$element.val(value).trigger("input", {
            origin: this.identifier
        });
    };
    Plugin.prototype.destroy = function() {
        this.$document.off("." + this.identifier);
        this.$window.off("." + this.identifier);
        this.$element.off("." + this.identifier).removeAttr("style").removeData("plugin_" + pluginName);
        if (this.$range && this.$range.length) {
            this.$range[0].parentNode.removeChild(this.$range[0]);
        }
    };
    $.fn[pluginName] = function(options) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this), data = $this.data("plugin_" + pluginName);
            if (!data) {
                $this.data("plugin_" + pluginName, data = new Plugin(this, options));
            }
            if (typeof options === "string") {
                data[options].apply(data, args);
            }
        });
    };
    return "rangeslider.js is available in jQuery context e.g $(selector).rangeslider(options);";
});

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, win, doc) {
    var SB_SPECIAL_BUTTON = "#selectbox_btn", SB_CONTAINER_SELECTOR = ".searcharea", SB_SEARCH_SELECTOR = ".searchselect", SB_INPUT_AREA_SELECTOR = ".inputarea", SB_ITEM_SELECTOR = ".searcharea a", SB_ACTIVE_CLASS = "on", SB_CI_PARAM = "ci", SB_CIID_PARAM = "ciid", SB_KGS_PARAM = "kgs", SB_BUAB_PARAM = "buab", SB_ZIP_PARAM = "plz", SB_DISTRICT_PARAM = "district", SB_QUARTER_PARAM = "quarter", SB_STANDARD_KW = "std_suchwort", SB_STANDARD_CI = "std_ort", SB_ADVANCED_NA = "adv_nachname", SB_ADVANCED_ST = "adv_strasse", SB_ADVANCED_NO = "adv_nr", SB_ADVANCED_CI = "adv_ort", SB_REVERSE_TEL = "rueck_telefonnummer", SB_CASH_CI = "geld_suchort", SB_CASH_ST = "geld_strasse", SB_CASH_NO = "geld_nr", SB_PHARMACY_ST = "notapo_strasse", SB_PHARMACY_NO = "notapo_nr", SB_PHARMACY_CI = "notapo_ort", SB_PHARMACY_TIME = "notapo_uhrzeit", SB_ZIP_ST = "plz_strasse", SB_ZIP_CI = "plz_ort", SB_ZIP_ZIP = "plz_plz", SB_EVENT_KW = "veranst_wen_was", SB_EVENT_CI = "veranst_ort", SB_AC_ST = "vorw_strasse", SB_AC_NO = "vorw_vorwahl", SB_AC_CI = "vorw_ort", SB_WIZ_KW = "Privatperson_Name", SEARCHBOX_TYPES = {
        search_std: {
            idSuffix: "Standardsuche",
            fields: [ SB_STANDARD_KW, SB_STANDARD_CI ],
            offsetTop: 354,
            selector: "i.icon-standard",
            ddClass: "standard",
            item: undefined
        },
        search_ext: {
            idSuffix: "ErweiterteSuche",
            fields: [ SB_ADVANCED_NA, SB_ADVANCED_ST, SB_ADVANCED_NO, SB_ADVANCED_CI ],
            offsetTop: 354,
            selector: "i.icon-spyglass",
            ddClass: "advanced"
        },
        search_inverse: {
            idSuffix: "Rueckwaertssuche",
            fields: [ SB_REVERSE_TEL ],
            offsetTop: 354,
            selector: "i.icon-rewind",
            ddClass: "reverse"
        },
        search_atm: {
            special: true,
            idSuffix: "Geldautomaten",
            fields: [ SB_CASH_ST, SB_CASH_NO, SB_CASH_CI ],
            offsetTop: 354,
            selector: "i.icon-cashcard",
            ddClass: "atm"
        },
        search_pha: {
            special: true,
            idSuffix: "Notapotheken",
            fields: [ SB_PHARMACY_ST, SB_PHARMACY_NO, SB_PHARMACY_CI ],
            offsetTop: 354,
            selector: "i.icon-aeskulap",
            ddClass: "pharmacy"
        },
        search_zip: {
            special: true,
            idSuffix: "PLZ",
            fields: [ SB_ZIP_ST, SB_ZIP_ZIP, SB_ZIP_CI ],
            deleteFields: [ [ SB_ZIP_ZIP ], [ SB_ZIP_ST, SB_ZIP_CI ] ],
            offsetTop: 354,
            selector: "i.icon-horn",
            ddClass: "postal"
        },
        search_areacode: {
            special: true,
            idSuffix: "Vorwahlen",
            fields: [ SB_AC_ST, SB_AC_NO, SB_AC_CI ],
            deleteFields: [ [ SB_AC_NO ], [ SB_AC_ST, SB_AC_CI ] ],
            offsetTop: 354,
            selector: "i.icon-phone",
            ddClass: "prefix"
        }
    }, namespace = global.getNamespace("search"), globalVars = global.vars, globalTools = globalVars.tools, globalVal = global.val, DEFAULT_OPTIONS, defaultLightboxAttr = {
        "data-width": 450,
        "data-max-height": 420,
        "data-lightbox-type": "iframe"
    }, INPUTS_NO = {}, INPUTS = {};
    INPUTS_NO[SB_STANDARD_CI] = [ SB_ADVANCED_CI, SB_ZIP_ZIP ];
    INPUTS_NO[SB_CASH_CI] = [ SB_ADVANCED_CI, SB_ZIP_ZIP ];
    INPUTS_NO[SB_PHARMACY_CI] = [ SB_ADVANCED_CI, SB_ZIP_ZIP ];
    INPUTS_NO[SB_EVENT_CI] = [ SB_ADVANCED_CI, SB_ZIP_ZIP ];
    INPUTS_NO[SB_AC_CI] = [ SB_ADVANCED_CI, SB_ZIP_ZIP ];
    INPUTS_NO[SB_ZIP_ZIP] = [ SB_STANDARD_CI, SB_CASH_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI ];
    INPUTS[SB_STANDARD_KW] = [ SB_ADVANCED_NA, SB_EVENT_KW ];
    INPUTS[SB_STANDARD_CI] = [ SB_CASH_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI, SB_ADVANCED_CI, SB_ZIP_CI ];
    INPUTS[SB_ADVANCED_NA] = [ SB_STANDARD_KW, SB_EVENT_KW ];
    INPUTS[SB_ADVANCED_CI] = [ SB_STANDARD_CI, SB_ZIP_CI, SB_CASH_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI ];
    INPUTS[SB_ADVANCED_ST] = [ SB_CASH_ST, SB_PHARMACY_ST, SB_ZIP_ST, SB_AC_ST ];
    INPUTS[SB_ADVANCED_NO] = [ SB_CASH_NO, SB_PHARMACY_NO, SB_ZIP_ZIP, SB_AC_NO ];
    INPUTS[SB_CASH_CI] = [ SB_STANDARD_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI, SB_ADVANCED_CI, SB_ZIP_CI ];
    INPUTS[SB_CASH_ST] = [ SB_PHARMACY_ST, SB_ADVANCED_ST, SB_ZIP_ST, SB_AC_ST ];
    INPUTS[SB_CASH_NO] = [ SB_ADVANCED_NO, SB_PHARMACY_NO, SB_ZIP_ZIP, SB_AC_NO ];
    INPUTS[SB_PHARMACY_TIME] = [];
    INPUTS[SB_PHARMACY_CI] = [ SB_STANDARD_CI, SB_CASH_CI, SB_EVENT_CI, SB_AC_CI, SB_ADVANCED_CI, SB_ZIP_CI ];
    INPUTS[SB_PHARMACY_ST] = [ SB_CASH_ST, SB_ADVANCED_ST, SB_ZIP_ST, SB_AC_ST ];
    INPUTS[SB_PHARMACY_NO] = [ SB_CASH_NO, SB_ADVANCED_NO, SB_ZIP_ZIP, SB_AC_NO ];
    INPUTS[SB_ZIP_ST] = [ SB_CASH_ST, SB_PHARMACY_ST, SB_ADVANCED_ST, SB_AC_ST ];
    INPUTS[SB_ZIP_CI] = [ SB_ADVANCED_CI, SB_STANDARD_CI, SB_CASH_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI ];
    INPUTS[SB_ZIP_ZIP] = [ SB_ADVANCED_CI ];
    INPUTS[SB_EVENT_KW] = [ SB_ADVANCED_NA, SB_STANDARD_KW ];
    INPUTS[SB_EVENT_CI] = [ SB_STANDARD_CI, SB_PHARMACY_CI, SB_CASH_CI, SB_AC_CI, SB_ADVANCED_CI, SB_ZIP_CI ];
    INPUTS[SB_AC_ST] = [ SB_CASH_ST, SB_PHARMACY_ST, SB_ZIP_ST, SB_ADVANCED_ST ];
    INPUTS[SB_AC_NO] = [ SB_CASH_NO, SB_PHARMACY_NO, SB_ZIP_ZIP, SB_ADVANCED_NO ];
    INPUTS[SB_AC_CI] = [ SB_STANDARD_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_CASH_CI, SB_ADVANCED_CI, SB_ZIP_CI ];
    DEFAULT_OPTIONS = {
        language: "de",
        reg: false,
        searchHistory: {},
        autoComplete: {
            delay: 200,
            minChars: 1,
            moreURL: "",
            moreParams: "",
            moreEvent: null,
            selectParams: "zvo_ok=4",
            matchSubset: false,
            onChangeTerm: null,
            selectFirst: false,
            autoSubmit: true,
            autoSelect: false
        },
        kwAutoComplete: {
            onChangeTerm: null,
            minChars: 1,
            delay: 200,
            matchSubset: false,
            selectFirst: false,
            autoSubmit: false
        },
        infoButton: {
            onClick: null,
            selector: {
                selectbox: SB_SPECIAL_BUTTON.substring(1, SB_SPECIAL_BUTTON.length),
                pharmacy: "Search_Notapotheken",
                cashpoint: "Search_Geldautomaten",
                zip: "Search_PLZ",
                areacode: "Search_Vorwahlen",
                event: "Search_Veranstaltungen",
                reverse: "Search_Rueckwaertssuche"
            },
            subSelector: ".info",
            lightboxAttr: {
                selectbox: defaultLightboxAttr,
                pharmacy: defaultLightboxAttr,
                cashpoint: defaultLightboxAttr,
                zip: defaultLightboxAttr,
                areacode: defaultLightboxAttr,
                event: defaultLightboxAttr,
                reverse: defaultLightboxAttr
            }
        },
        searchSelector: {},
        radiusSearch: {
            onSlide: undefined,
            onSlideEnd: undefined
        },
        moetb: {
            selector: "#moetb .arrow, .openoverlay",
            toggleClass: ".overlay"
        },
        sbContainer: {
            selector: ".stage",
            hSelector: ".inputarea",
            addHeight: 20,
            startPage: "#oetbwrap.startpage",
            emptyClass: "empty",
            clearClass: "clearme"
        },
        wipe: {
            analyzer: undefined,
            enabled: true,
            attr: {
                clearInput: "Suchmaske_leeren"
            }
        },
        onClickClearInput: undefined
    };
    function SearchboxHandler(onClick, sbOptions, addParams, onAfterChange) {
        var self = this, autoCompleter, wizAutoCompleter, wizKwAutoCompleter, kwAutoCompleter, adCache = {}, options, selectedItem, prevSelectedItem, selectorHandler, searchHistory, searchboxTypes = namespace.SB_TYPES;
        this.types = namespace.SB_TYPES;
        function init() {
            options = $.extend(true, {}, DEFAULT_OPTIONS, sbOptions || {});
            if (globalVal.isUndefined(options.autoComplete) || options.autoComplete === null) {
                options.autoComplete = DEFAULT_OPTIONS.autoComplete;
            }
            if (options.autoComplete.minChars < 1) {
                options.autoComplete.minChars = DEFAULT_OPTIONS.autoComplete.minChars;
            }
            if (globalVal.isUndefined(options.kwAutoComplete) || options.kwAutoComplete === null) {
                options.kwAutoComplete = DEFAULT_OPTIONS.kwAutoComplete;
            }
            if (options.kwAutoComplete.minChars < 1) {
                options.kwAutoComplete.minChars = DEFAULT_OPTIONS.kwAutoComplete.minChars;
            }
            selectorHandler = new SearchSelectorHandler(options.searchSelector);
            searchHistory = new global.search.SearchHistory(options.searchHistory);
            $(options.moetb.selector).on("click", function() {
                $(options.moetb.toggleClass).toggle();
            });
            if (!("placeholder" in doc.createElement("input"))) {
                $("input").each(function() {
                    var ph = "placeholder", $input = $(this);
                    if ($input.val() === "") {
                        $input.val($input.attr(ph));
                    }
                    $input.on("click", function() {
                        if ($input.val() === $input.attr(ph)) {
                            $input.val("");
                        }
                    }).blur(function() {
                        if ($input.val() === "") {
                            $input.val($input.attr(ph));
                        }
                    });
                });
            }
        }
        this.bindEvents = function() {
            var firstItem, $items, item, $item, searchBoxType;
            $items = $(SB_ITEM_SELECTOR);
            for (var i = 0; i < $items.length; i++) {
                item = $items[i];
                $item = $(item);
                searchBoxType = getSearchBoxTypeBySelector($item);
                if (globalVal.isUndefined(searchBoxType)) {
                    continue;
                }
                searchBoxType.item = item;
                if (globalVal.isUndefined(firstItem)) {
                    firstItem = item;
                }
                $item.on("click touchstart", null, self, onItemClick);
                item.searchType = searchBoxType;
            }
            selectedItem = $(SB_SEARCH_SELECTOR);
            selectedItem.searchType = getSearchBoxTypeBySelector(selectedItem);
            selectorHandler.bindEvents();
            if (globalVal.isUndefined(firstItem)) {
                global.trace("Error - SearchBoxHandler:  No navigation items available. Stop processing.");
                return;
            }
            if (globalVal.isUndefined(selectedItem)) {
                selectedItem = firstItem;
            }
            updateType(selectedItem.searchType, $(SB_CONTAINER_SELECTOR).html(), addParams, false);
            doPostSelections();
            globalVars.stickyController = new global.search.StickyController(SB_CONTAINER_SELECTOR);
        };
        this.select = function(type) {
            if (!type.item) {
                return;
            }
            if (type === prevSelectedItem.searchType) {
                return;
            }
            $(type.item).trigger("click");
        };
        function doPostSelections() {
            var idSuffix, radiusSearchOptions = {
                values: {}
            };
            buildHiddenFields(SB_CONTAINER_SELECTOR + " " + SB_INPUT_AREA_SELECTOR);
            idSuffix = selectedItem.searchType.idSuffix;
            if (idSuffix === "Geldautomaten" || idSuffix === "Notapotheken" || idSuffix === "ErweiterteSuche") {
                if (idSuffix === "ErweiterteSuche") {
                    radiusSearchOptions.values.min = 0;
                    radiusSearchOptions.values.value = 0;
                }
                radiusSearchOptions = $.extend(true, radiusSearchOptions, options.radiusSearch);
                globalVars.radiusSearch = new namespace.RadiusSearchHandler(radiusSearchOptions);
            }
            bindInputFieldEvents(selectedItem);
            bindAutoCompleteFields();
            prevSelectedItem = selectedItem;
            activateClearFunction();
            onAfterItemChange();
        }
        function activateClearFunction() {
            var fieldBlocks = doc.querySelectorAll(SB_CONTAINER_SELECTOR + " ." + options.sbContainer.clearClass);
            fieldBlocks.forEach(function(inputParent, idx) {
                try {
                    var input = inputParent.querySelector("input"), clear = inputParent.querySelector("span"), emptyClass = options.sbContainer.emptyClass;
                    clear.addEventListener("click", onClickClearSymbol);
                    if (global.util.DOM.isVisible(inputParent)) {
                        if (input.value.trim() === "") {
                            inputParent.classList.add(emptyClass);
                        } else {
                            inputParent.classList.remove(emptyClass);
                        }
                    }
                    input.addEventListener("input", function(event) {
                        if (this.value === "") {
                            inputParent.classList.add(emptyClass);
                        } else {
                            inputParent.classList.remove(emptyClass);
                        }
                    });
                } catch (e) {
                    global.trace(e);
                }
            });
        }
        function onClickClearSymbol(event) {
            event.preventDefault();
            var fieldBlock = this.closest("." + options.sbContainer.clearClass), wipeOpt = options.wipe, analyzer = wipeOpt.analyzer, trackingEnabled = wipeOpt.enabled && !!analyzer, emptyClass = options.sbContainer.emptyClass, inputField;
            fieldBlock.classList.add(emptyClass);
            inputField = fieldBlock.querySelector("input");
            inputField.value = "";
            inputField.focus();
            if (trackingEnabled) {
                if (!global.util.AnalyzerCheck.isValidAnalyzer(wipeOpt)) {
                    global.error(global.util.AnalyzerCheck.getNoAnalyzerErrorText(), wipeOpt);
                } else {
                    analyzer.logAction(wipeOpt.attr.clearInput);
                }
            }
            if (global.val.isFunction(options.onClickClearInput)) {
                options.onClickClearInput.call(this, event);
            }
        }
        this.getValues = function() {
            var result = [], inputFields = $(SB_CONTAINER_SELECTOR + " input"), item;
            for (var i = 0; i < inputFields.length; i++) {
                item = inputFields[i];
                if (globalTools.isCheckbox(item) && !item.checked) {
                    continue;
                }
                result[item.name] = $(item).val();
            }
            return result;
        };
        this.getValuesAsQueryString = function() {
            var paramCodec = new global.util.QueryStringCodec();
            return paramCodec.encode(this.getValues(), false);
        };
        function onItemClick(event) {
            var selectedItemSearchType, selectedItemLifeTime, searchTypeInfo, eventListenerInfo = {};
            if (autoCompleter) {
                autoCompleter.hideResultsNow();
            }
            if (kwAutoCompleter) {
                kwAutoCompleter.hideResultsNow();
            }
            if (wizAutoCompleter) {
                wizAutoCompleter.hideResultsNow();
            }
            if (wizKwAutoCompleter) {
                wizKwAutoCompleter.hideResultsNow();
            }
            if (selectorHandler) {
                selectorHandler.hideSelectbox();
            }
            selectedItem = this;
            selectedItemSearchType = selectedItem.searchType;
            selectedItemLifeTime = globalVal.isNumber(selectedItemSearchType.lifeTime) ? selectedItemSearchType.lifeTime : 0;
            searchTypeInfo = {
                lifeTime: new Date().getTime() - selectedItemLifeTime,
                filled: !!selectedItemSearchType.filled
            };
            eventListenerInfo.event = event;
            eventListenerInfo.element = selectedItem;
            eventListenerInfo.searchType = selectedItemSearchType;
            eventListenerInfo.searchTypeInfo = searchTypeInfo;
            if (!globalVal.isFunction(onClick) || onClick(eventListenerInfo)) {
                internalSetHTML(selectedItemSearchType, selectedItemSearchType.html, selectedItemSearchType.addParams, true);
            }
            return false;
        }
        function onAfterItemChange() {
            if (globalVal.isFunction(onAfterChange)) {
                onAfterChange(selectedItem.searchType);
            }
        }
        function bindInputFieldEvents(selectedItem) {
            var searchType;
            searchType = selectedItem.searchType || {};
            if (searchType.hasOwnProperty("disableFields")) {
                bindInputFieldEventsByProperty(searchType, "disableFields", bindDisableInputFieldEvent);
            }
            if (searchType.hasOwnProperty("deleteFields")) {
                bindInputFieldEventsByProperty(searchType, "deleteFields", bindDeleteInputFieldEvent);
            }
        }
        function bindInputFieldEventsByProperty(searchType, property, eventHandler) {
            var fieldGroupIds, fields = searchType[property];
            if (!globalVal.isArray(fields) || fields.length !== 2) {
                return;
            }
            for (var i = 0; i < fields.length; i++) {
                if (globalVal.isString(fields[i])) {
                    fields[i] = [ fields[i] ];
                }
            }
            fieldGroupIds = fields[0];
            for (var j = 0; j < fieldGroupIds.length; j++) {
                eventHandler(fieldGroupIds[j], fieldGroupIds, fields[1]);
            }
            fieldGroupIds = fields[1];
            for (var k = 0; k < fieldGroupIds.length; k++) {
                eventHandler(fieldGroupIds[k], fieldGroupIds, fields[0]);
            }
        }
        function bindDeleteInputFieldEvent(inputFieldId, groupMemberIds, deleteFieldIds) {
            deleteInputFields(inputFieldId, groupMemberIds, deleteFieldIds);
            $("#" + inputFieldId).on("input blur", function(event) {
                deleteInputFields($(this).attr("id"), groupMemberIds, deleteFieldIds);
            });
        }
        function bindDisableInputFieldEvent(inputFieldId, groupMemberIds, disableFieldIds) {
            disableInputFields(inputFieldId, groupMemberIds, disableFieldIds);
            $("#" + inputFieldId).on("input blur", function(event) {
                disableInputFields($(this).attr("id"), groupMemberIds, disableFieldIds);
            });
        }
        function deleteInputFields(elementId, groupMemberIds, deleteFieldIds) {
            var $field, $toClearField;
            $field = $("#" + elementId);
            if (!$field.length) {
                global.log("No element available with id: '" + elementId + "'");
                return;
            }
            if ($field.val().length >= 1) {
                for (var i = 0; i < deleteFieldIds.length; i++) {
                    $toClearField = $("#" + deleteFieldIds[i]);
                    $toClearField.val("");
                    $toClearField.parent().addClass(options.sbContainer.emptyClass);
                }
            }
        }
        function disableInputFields(elementId, groupMemberIds, disableFieldIds) {
            var $field, $groupMember;
            $field = $("#" + elementId);
            if (!$field.length) {
                global.log("No element available with id: '" + elementId + "'");
                return;
            }
            if ($field.val().length >= 1) {
                for (var i = 0; i < disableFieldIds.length; i++) {
                    $("#" + disableFieldIds[i]).prop("disabled", true);
                }
            } else {
                for (var j = 0; j < disableFieldIds.length; j++) {
                    for (var k = 0; k < groupMemberIds.length; k++) {
                        $groupMember = $("#" + groupMemberIds[k]);
                        if ($groupMember.length > 0 && $groupMember.val() !== "") {
                            return;
                        }
                    }
                    $("#" + disableFieldIds[j]).prop("disabled", false);
                }
            }
        }
        function addHiddenFields(targetSelector, hiddens) {
            var $target = $(targetSelector);
            for (var i = 0; i < $target.length; i++) {
                for (var j = 0; j < hiddens.length; j++) {
                    if (i === 0) {
                        $($target[i]).prepend(hiddens[j]);
                    } else {
                        $(hiddens[j]).clone().prependTo($target[i]);
                    }
                }
            }
        }
        function getHiddenFields(targetSelector) {
            var hiddens = [], $target = $(targetSelector), inputs;
            if ($target.length <= 0) {
                return hiddens;
            }
            inputs = $($target[0]).children("input[type='hidden']");
            for (var i = 0; i < inputs.length; i++) {
                if (inputs[i].type !== "hidden") {
                    continue;
                }
                if (prevSelectedItem.searchType.addParams && prevSelectedItem.searchType.addParams[inputs[i].name]) {
                    continue;
                }
                hiddens.push(inputs[i]);
            }
            return hiddens;
        }
        function updateType(searchType, html, addParams, filled) {
            searchType.html = html;
            searchType.lifeTime = new Date().getTime();
            searchType.filled = globalVal.isDefined(filled) ? filled : true;
            searchType.addParams = addParams ? globalTools.getAsObject(addParams) : {};
        }
        this.setHTML = function(searchboxType, html, addParams) {
            if (searchboxType === prevSelectedItem.searchType) {
                return;
            }
            internalSetHTML(searchboxType, html, addParams);
        };
        function internalSetHTML(searchboxType, html, addParams, direct) {
            var $form, hiddenFields, userInputs, targetSelector = SB_CONTAINER_SELECTOR + " " + SB_INPUT_AREA_SELECTOR;
            destroyRangeSlider();
            updateType(searchboxType, html, addParams);
            if (selectedItem.searchType !== searchboxType && !direct) {
                return;
            }
            hiddenFields = getHiddenFields(targetSelector);
            userInputs = getUserInputs(prevSelectedItem.searchType.fields);
            $form = $(SB_CONTAINER_SELECTOR + " form");
            $form.replaceWith(html);
            addHiddenFields(targetSelector, hiddenFields);
            restoreUserInputs(userInputs.values, userInputs.checks);
            selectorHandler.updateFirstChild(searchboxType);
            doPostSelections();
        }
        function destroyRangeSlider() {
            var obj;
            for (var prop in globalVars) {
                if (globalVars.hasOwnProperty(prop)) {
                    obj = globalVars[prop];
                    if (globalVal.isDefined(namespace.RadiusSearchHandler) && obj instanceof namespace.RadiusSearchHandler) {
                        obj.destroyRangeSlider();
                    }
                }
            }
        }
        function getUserInputs(fields) {
            var value, values = {}, checks = {}, el;
            for (var i = 0; i < fields.length; i++) {
                el = $("#" + fields[i])[0];
                if (!el || !el.id) {
                    continue;
                }
                if ($(el).val()) {
                    value = $(el).val();
                    if (globalTools.isCheckbox(el)) {
                        if (!el.checked) {
                            value = "";
                        } else {
                            checks[el.id] = el.checked;
                        }
                    }
                    values[el.id] = value;
                }
            }
            return {
                values: values,
                checks: checks
            };
        }
        function restoreUserInputs(values, checks) {
            var used, arr, el;
            for (var prop in values) {
                if (!values.hasOwnProperty(prop)) {
                    continue;
                }
                used = false;
                if (globalVal.isNumber(values[prop])) {
                    arr = INPUTS_NO[prop];
                    if (arr) {
                        arr.push(prop);
                        for (var j = 0; j < arr.length; j++) {
                            el = $("#" + arr[j]);
                            if (!el || el.length !== 1) {
                                continue;
                            }
                            $(el[0]).val(values[prop]);
                            used = true;
                            break;
                        }
                    }
                }
                if (used) {
                    continue;
                }
                arr = INPUTS[prop];
                if (!arr) {
                    continue;
                }
                arr.push(prop);
                for (var k = 0; k < arr.length; k++) {
                    el = $("#" + arr[k]);
                    if (!el || el.length !== 1) {
                        continue;
                    }
                    if (globalTools.isCheckbox(el[0])) {
                        el[0].checked = typeof checks[prop] !== "undefined";
                    } else {
                        $(el[0]).val(values[prop]);
                    }
                }
            }
        }
        function buildHiddenFields(targetSelector) {
            var names, targets, property, params, addParams;
            names = [ SB_CIID_PARAM, SB_DISTRICT_PARAM, SB_QUARTER_PARAM, SB_KGS_PARAM, SB_BUAB_PARAM, SB_ZIP_PARAM ];
            targets = $(targetSelector);
            if (targets.length <= 0) {
                global.log("SearchBoxHandler Error: Hidden fields target missing. Stop processing.");
                return;
            }
            params = globalTools.getAsObject(options.autoComplete.selectParams);
            addParams = selectedItem.searchType.addParams;
            for (var i = 0; i < targets.length; i++) {
                for (var j = 0; j < names.length; j++) {
                    addElement(targets[i], buildHiddenField(names[j]), names[j]);
                }
                for (property in addParams) {
                    if (addParams.hasOwnProperty(property)) {
                        addElement(targets[i], buildHiddenField(property, addParams[property]), property);
                    }
                }
                for (property in params) {
                    if (params.hasOwnProperty(property)) {
                        addElement(targets[i], buildHiddenField(property), property);
                    }
                }
            }
        }
        function buildHiddenField(name, value) {
            var inputField;
            if (globalVal.isUndefined(name)) {
                global.log("Undefined hidden field name parameter. Stop processing.");
                return;
            }
            inputField = globalTools.createEl("input");
            inputField.type = "hidden";
            inputField.name = name;
            if (globalVal.isDefined(value)) {
                inputField.value = value;
            }
            return inputField;
        }
        function addElement(target, element, elementName) {
            if ($(target).find("input[name='" + elementName + "']").length > 0 || globalVal.isUndefined(element)) {
                return;
            }
            $(target).prepend(element);
        }
        this.setAutoCompleteData = function(item, term, data, autoCompleteOptions, ad) {
            var values = [], suggestionList = [];
            function addAutoCompleteData(suggestions, isHistoryData) {
                var contains, sortItem, item;
                for (var i = 0; i < suggestions.length; i++) {
                    item = suggestions[i];
                    contains = false;
                    $.each(suggestionList, function(idx, historyItem) {
                        if (item.cokey && historyItem.cokey && global.str.equalsIgnoreCase(item.cokey, historyItem.cokey)) {
                            contains = true;
                            return false;
                        }
                    });
                    if (!contains) {
                        suggestionList.push(item);
                        sortItem = [];
                        sortItem.push(item.na ? item.na : "");
                        sortItem.push(item.ciid ? item.ciid : "");
                        sortItem.push(item.cokey ? item.cokey : "");
                        sortItem.push(item.district ? item.district : "");
                        sortItem.push(item.quarter ? item.quarter : "");
                        sortItem.push(item.pc ? item.pc : "");
                        if (globalVal.isArray(item.sectlist)) {
                            sortItem.push(item.sectlist.join(","));
                        } else if (globalVal.isString(item.sectlist)) {
                            sortItem.push(item.sectlist);
                        } else {
                            sortItem.push("");
                        }
                        if (isHistoryData && i + 1 === suggestions.length) {
                            sortItem.push(true);
                        } else {
                            sortItem.push(false);
                        }
                        values.push(sortItem);
                    }
                }
            }
            self.changeKwKeyPrefix(term);
            if (data && globalVal.isObject(data)) {
                data.history = globalVal.isArray(data.history) ? data.history : [];
                data.std = globalVal.isArray(data.std) ? data.std : [];
                addAutoCompleteData(data.history, true);
                addAutoCompleteData(data.std);
            }
            values.useMore = autoCompleteOptions.useMore;
            if (ad) {
                adCache[generateCacheKey(autoCompleter, term.toLowerCase())] = ad;
            }
            $(item).setACData(values, term);
        };
        function generateCacheKey(autoCompleter, term) {
            var obj = {};
            autoCompleter.generateCacheKey(term, obj);
            return obj.key;
        }
        this.generateAd = function(options) {
            var defaultOptions = {
                link: "#",
                name: "",
                address: "",
                src: "",
                text: "Mehr Informationen &ndash; hier klicken!",
                clickCallback: null,
                clickCallbackParam: "",
                phone: "",
                adHintText: "Anzeige"
            }, opt, container, link, linkTag, addressTag, phoneTag, textLink, textTag, adHintTag, imgTag, imgWidth = 100, imgHeight = 50, imgContainerId = global.util.Tools.getUniqueKey();
            try {
                opt = $.extend(true, {}, defaultOptions, options);
                container = $('<div style="background: linear-gradient(180deg, rgba(252,252,252,1) 0%, rgba(238,238,238,1) 50%);">');
                adHintTag = $('<p style="margin:0; padding-inline:5px; font-size:11px;">').html(opt.adHintText);
                link = $('<a style="color: #000; text-decoration: none; font-weight: bold;font-size:12px;">').attr("href", opt.link).html(opt.name);
                if (globalVal.isFunction(opt.clickCallback)) {
                    link.on("click", function() {
                        opt.clickCallback(opt.clickCallbackParam);
                    });
                }
                linkTag = $('<p style="margin:0; padding:5px; font-size:11px;">').append(link);
                addressTag = $('<p style="margin:0; padding:5px 5px 0 5px; font-size:11px;">').html(!opt.address || opt.address === "" ? "&nbsp;" : opt.address);
                phoneTag = $('<p style="margin:0; padding:0 5px 5px 5px; font-size:11px;">').html(!opt.phone || opt.phone === "" ? "&nbsp;" : opt.phone);
                if (opt.text && opt.text !== "") {
                    textLink = $("<a>").attr("href", opt.link).html(opt.text);
                    if (globalVal.isFunction(opt.clickCallback)) {
                        textLink.on("click", function(event) {
                            opt.clickCallback(opt.clickCallbackParam, event);
                        });
                    }
                } else {
                    textLink = $("<span>").html("&nbsp;");
                }
                textTag = $('<p style="margin:0; padding:5px; font-size: 12px;">').append(textLink);
                if (opt.src && opt.src !== "") {
                    imgTag = $('<p style="margin:0; padding:5px; font-size:11px;">').append($("<img>").attr({
                        src: opt.src,
                        width: imgWidth,
                        height: imgHeight,
                        alt: ""
                    }));
                } else {
                    imgTag = $('<p style="margin:0; padding:5px; font-size:11px;">').attr({
                        id: imgContainerId
                    }).css({
                        height: imgHeight + "px"
                    });
                }
                container.append(adHintTag).append(linkTag).append(addressTag).append(phoneTag).append(imgTag).append(textTag);
                return container;
            } catch (ex) {
                global.log("Error SearchboxHandler.generateAd: " + ex);
            }
        };
        this.generateAdHint = function(options) {
            var defaultOptions = {
                headline: "",
                link: "#",
                text: "Mehr Informationen erhalten sie bei Ihrem Das &Ouml;rtliche Verlag",
                paddingTopBottom: 50,
                clickCallback: null,
                clickCallbackParam: ""
            }, opts, container, link;
            try {
                opts = $.extend(defaultOptions, options);
                container = $('<div style="padding-block: 50px;background: linear-gradient(180deg, rgba(252,252,252,1) 0%, rgba(238,238,238,1) 50%);">').css({
                    padding: opts.paddingTopBottom + "px 0"
                }).append($('<p style="font-size:14px;font-weight:bold;margin:0;padding: 5px;">').html(opts.headline));
                if (opts.text) {
                    link = $('<a style="color:#000;">').attr("href", opts.link).html(opts.text);
                    if (globalVal.isFunction(opts.clickCallback)) {
                        link.on("click", function(event) {
                            opts.clickCallback(opts.clickCallbackParam, event);
                        });
                    }
                    container.append($('<p style="margin:0;padding: 5px;">').append(link));
                }
                return container;
            } catch (ex) {
                global.log("Error SearchboxHandler.generateAdHint: " + ex);
            }
        };
        this.setAutoCompleteKeyword = function(item, term, data, ad) {
            self.changeKeyPrefix(term);
            var values = [], kwList = [];
            data.history = globalVal.isArray(data.history) ? data.history : [];
            data.std = globalVal.isArray(data.std) ? data.std : [];
            $.each(data.history, function(key, histItem) {
                var contains = false;
                $.each(kwList, function(idx, kwItem) {
                    if (global.str.equalsIgnoreCase(histItem.kw, kwItem.kw)) {
                        contains = true;
                        return false;
                    }
                });
                if (!contains) {
                    kwList.push(histItem);
                }
                if (key === data.history.length - 1) {
                    kwList[kwList.length - 1].addDividingLine = true;
                }
            });
            $.each(data.std, function(key, stdItem) {
                var contains = false;
                $.each(kwList, function(idx, kwItem) {
                    if (global.str.equalsIgnoreCase(stdItem.kw, kwItem.kw)) {
                        contains = true;
                        return false;
                    }
                });
                if (!contains) {
                    kwList.push(stdItem);
                }
            });
            $.each(kwList, function(key, val) {
                values[key] = [];
                values[key].push(val.kw);
                if (val.addDividingLine) {
                    values[key][7] = true;
                }
            });
            if (ad) {
                adCache[generateCacheKey(kwAutoCompleter, term.toLowerCase())] = ad;
            }
            $(item).setACData(values, term);
        };
        this.changeKwKeyPrefix = function(keyPrefix) {
            if (kwAutoCompleter && globalVal.isDefined(kwAutoCompleter.getInput())) {
                kwAutoCompleter.getInput().data("ac_keyprefix", keyPrefix);
            }
        };
        this.changeKeyPrefix = function(keyPrefix) {
            if (autoCompleter && globalVal.isDefined(autoCompleter.getInput())) {
                autoCompleter.getInput().data("ac_keyprefix", keyPrefix);
            }
        };
        function beforeShow(ac, opt, value, width) {
            var fixAdWidth = 202, el = ac.getContainer(), oldWidth, leftDelta = 0, ad, adDiv, adWidth;
            if (!el.data("oetb_origWidth")) {
                el.data("oetb_origWidth", width);
            }
            oldWidth = el.data("oetb_origWidth");
            $("#" + opt.adId).remove();
            el.width(oldWidth);
            ad = adCache[generateCacheKey(ac, value.toLowerCase())];
            if (ad) {
                adDiv = $('<div style="width: 202px; float: right; border:1px solid #CCC; padding:5px; margin:5px; font-size:12px;">').attr({
                    id: opt.adId
                }).append(ad).width(fixAdWidth).css("float", opt.adFloating);
                el.children("ul").width(oldWidth).css("float", opt.adFloating);
                el.append(adDiv);
                adWidth = adDiv.outerWidth(true);
                opt.width = oldWidth + adWidth;
                if (opt.adFloating === "right") {
                    leftDelta = -adWidth;
                }
                opt.leftDelta = leftDelta;
                el.width(opt.width);
            } else {
                opt.width = oldWidth;
                opt.leftDelta = 0;
            }
        }
        function buildAcOptions(autoCompleteOptions, data) {
            autoCompleteOptions = globalTools.getAsObject(autoCompleteOptions);
            var language = globalVars.languages.getLanguage(options.language), moreURL = autoCompleteOptions.moreURL, addParams = [], acOptions, params = $.extend({}, globalTools.getAsObject(autoCompleteOptions.moreParams), selectedItem.searchType.addParams), selectParams = globalTools.getAsObject(autoCompleteOptions.selectParams);
            addParams.push(SB_CIID_PARAM);
            addParams.push(SB_KGS_PARAM);
            addParams.push(SB_DISTRICT_PARAM);
            addParams.push(SB_QUARTER_PARAM);
            addParams.push(SB_ZIP_PARAM);
            addParams.push(SB_BUAB_PARAM);
            acOptions = $.extend({}, autoCompleteOptions);
            acOptions.addParams = addParams;
            acOptions.moreParams = params;
            acOptions.selectParams = selectParams;
            acOptions.moreText = language.search.more.linkText;
            acOptions.moreValueParam = SB_CI_PARAM;
            acOptions.cacheLength = 1e3;
            acOptions.data = data;
            return acOptions;
        }
        function bindAutoCompleteFields() {
            var fields = [ SB_STANDARD_CI, SB_CASH_CI, SB_PHARMACY_CI, SB_EVENT_CI, SB_AC_CI, SB_ADVANCED_CI, SB_ZIP_CI ], kwFields = [ SB_STANDARD_KW, SB_ADVANCED_NA, SB_EVENT_KW, SB_WIZ_KW ];
            function bindAutoCompleteFieldByType(inputType, autoComplete, kwContext) {
                var acOptions, data, $input = $("#" + inputType), $body = $("body"), change = "change";
                if ($input.length === 0) {
                    return;
                }
                if (kwContext) {
                    acOptions = $.extend({}, autoComplete);
                    acOptions.onBeforeShow = beforeShow;
                    acOptions.adFloating = "left";
                    acOptions.adId = global.util.Tools.getUniqueKey();
                    kwAutoCompleter = $input.autocomplete(autoComplete.data, acOptions);
                    $input.on(change, function() {
                        self.changeKeyPrefix(this.value);
                    });
                    self.changeKwKeyPrefix(autoComplete.keyPrefix);
                } else {
                    data = autoComplete.data;
                    acOptions = buildAcOptions(autoComplete);
                    acOptions.onBeforeShow = beforeShow;
                    acOptions.adFloating = "right";
                    acOptions.adId = global.util.Tools.getUniqueKey();
                    autoCompleter = $input.autocomplete(data, acOptions);
                    $input.on(change, function() {
                        self.changeKwKeyPrefix(this.value);
                    });
                    self.changeKeyPrefix(autoComplete.keyPrefix);
                    wizAutoCompleter = $(".wiz_leftbox #Ort_PLZ").autocomplete(data, acOptions);
                    if (inputType === SB_WIZ_KW) {
                        wizKwAutoCompleter = $("#" + SB_WIZ_KW).autocomplete(data, acOptions);
                    }
                    $body.on("click touchstart", function() {
                        if (autoCompleter) {
                            autoCompleter.hideResultsNow();
                        }
                        if (wizAutoCompleter) {
                            wizAutoCompleter.hideResultsNow();
                        }
                        if (kwAutoCompleter) {
                            kwAutoCompleter.hideResultsNow();
                        }
                        if (wizKwAutoCompleter) {
                            wizKwAutoCompleter.hideResultsNow();
                        }
                        if (selectorHandler) {
                            selectorHandler.hideSelectbox();
                        }
                    });
                }
            }
            try {
                for (var i = 0; i < fields.length; i++) {
                    bindAutoCompleteFieldByType(fields[i], options.autoComplete);
                }
                for (var j = 0; j < kwFields.length; j++) {
                    bindAutoCompleteFieldByType(kwFields[j], options.kwAutoComplete, true);
                }
            } catch (ex) {
                global.log("ERROR: bindAutoCompleteFields: " + ex);
            }
        }
        function getSearchBoxTypeBySelector($item) {
            for (var type in searchboxTypes) {
                if (searchboxTypes.hasOwnProperty(type) && ($item.hasClass(searchboxTypes[type].ddClass) || $item.find(searchboxTypes[type].selector).length !== 0)) {
                    return searchboxTypes[type];
                }
            }
        }
        this.getSearchHistoryInstance = function() {
            return searchHistory;
        };
        this.getSearchHistory = function(callback, type) {
            searchHistory.get(callback, type);
        };
        this.getKeywordHistory = function(callback) {
            searchHistory.get(callback, "sekw");
        };
        this.getCityHistory = function(callback) {
            searchHistory.get(callback, "seci");
        };
        this.setSearchHistory = function(data, callback) {
            searchHistory.set(data, callback, true);
        };
        this.addSearchHistory = function(data, callback) {
            searchHistory.add(data, callback);
        };
        function addSearchHistoryItem(kw, ci, arKey, cat, catMatch, callback, update) {
            searchHistory.addSearch(kw, ci, arKey, cat, catMatch, callback, update);
        }
        this.addHitlistSearchHistoryItem = function(kw, ci, arKey, cat, catMatch, onAdd) {
            addSearchHistoryItem(kw, ci, arKey, cat, catMatch, onAdd, false);
        };
        this.addDetailviewSearchHistoryItem = function(kw, ci, arKey, cat, callback) {
            addSearchHistoryItem(kw, ci, arKey, cat, null, callback, true);
        };
        this.removeSearchHistory = function(callback) {
            searchHistory.remove(callback);
        };
        this.removeRegionFromSearchHistory = function(name, arKey, afterRemove) {
            searchHistory.removeRegionFromSearchHistory(name, arKey, afterRemove);
        };
        this.removeKeywordFromSearchHistory = function(kw, callback) {
            searchHistory.removeKeywordFromSearchHistory(kw, callback);
        };
        this.enableSearchHistory = function() {
            searchHistory.enable();
        };
        this.disableSearchHistory = function(removeCallback) {
            searchHistory.disable(removeCallback);
        };
        init();
    }
    function SearchSelectorHandler(opts) {
        var self = this, options, DEFAULT_OPTIONS = {
            selector: {
                click: ".searchselect",
                dropDown: ".searchdrop"
            },
            slideTime: 50
        }, selector, first = " li:first", notFirst = " li:not(:first)";
        function init(opts) {
            options = $.extend(true, {}, DEFAULT_OPTIONS, opts || {});
            selector = options.selector;
        }
        init(opts);
        this.bindEvents = function() {
            $(selector.click).on("click", null, self, onClick);
            $(selector.click).parent().on("mouseleave", null, self, onMouseLeave);
        };
        function onClick(ev) {
            if ($(selector.dropDown).next("li").is(":visible")) {
                self.hideSelectbox();
            } else {
                self.showSelectbox();
            }
            return false;
        }
        function onMouseLeave(ev) {
            self.hideSelectbox();
        }
        this.hideSelectbox = function() {
            $(selector.dropDown).slideUp({
                duration: options.slideTime
            });
        };
        this.showSelectbox = function() {
            $(selector.dropDown).toggleClass("gone", false);
            $(selector.dropDown).slideDown({
                duration: options.slideTime
            });
        };
        this.updateFirstChild = function(searchType) {
            var sel = selector.click, $firstElement = $(sel);
            $firstElement.attr("class", sel.substr(1, sel.length) + " " + searchType.ddClass);
        };
    }
    namespace.SearchboxHandler = SearchboxHandler;
    namespace.SB_TYPES = $.extend(true, {}, SEARCHBOX_TYPES);
    namespace.SB_ACTIVE_CLASS = SB_ACTIVE_CLASS;
})($oe$, this, document);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, win, doc) {
    var namespace = global.getNamespace("search");
    function SimpleSearchboxHandler(opts) {
        var self = this, options, DEFAULT_OPTIONS = {
            selector: {
                searchArea: ".search",
                searchFormId: "searchbox",
                inputId: "std_ort",
                inputParent: ".inputarea",
                clearItem: ".inputarea span.clearme",
                locateItem: ".inputarea span.locateme",
                suggestionListId: "suggestionList",
                hintItemId: "hintItem"
            },
            errors: {
                geolocation: {
                    PERMISSION_DENIED: {
                        msg: "Fehler. Die Standortfreigabe ist nicht aktiviert."
                    },
                    POSITION_UNAVAILABLE: {
                        msg: "Interner Fehler. Positionsabfrage fehlgeschlagen."
                    },
                    TIMEOUT: {
                        msg: "Fehler. Zeitüberschreitung bei der Positionsabfrage."
                    }
                },
                default: "Es ist ein interner Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
            },
            wipe: {
                analyzer: undefined,
                enabled: true,
                action: {
                    geolocation: {
                        iconClick: "Positionsabfrage_starten_Icon",
                        suggesterEntryClick: "Positionsabfrage_starten_Text",
                        permissionGranted: "Positionsabfrage_genehmigt",
                        permissionDenied: "Positionsabfrage_verweigert"
                    },
                    clearInput: "Suchmaske_leeren",
                    sendForm: "Formular_senden",
                    suggesterCityClick: "Ortsvorschlag_ausgewählt"
                },
                error: {
                    geolocation: {
                        positionUnavailable: "Positionsabfrage_fehlgeschlagen",
                        timeout: "Positionsabfrage_Zeitüberschreitung"
                    }
                },
                type: {
                    ACTION: "ACTION",
                    ERROR: "ERROR"
                }
            },
            autoComplete: {
                delay: 200,
                minChars: 1,
                onChangeTerm: undefined,
                autoSubmit: false,
                selectParams: "zvo_ok=4"
            },
            geolocation: {
                onGetCurrentPosition: undefined,
                text: "Meinen Standort verwenden",
                type: "geolocation"
            },
            hideClass: "gone",
            addGeolocationRow: true,
            maxCacheTime: 3600 * 1e3,
            doHighlight: true,
            hiddenFields: {
                property: "hiddenFields",
                cityKeyName: "kgs"
            }
        }, selector, searchForm, inputParent, areaInput, clearItem, hintItem, geoLocationItem, currentHiddenFields = [], suggestionCache, analyzer, wipeOpt, trackingEnabled, hiddenFieldsProperty, autoCompleteOptions, timeout;
        function init(opts) {
            options = global.obj.deepMerge({}, DEFAULT_OPTIONS, opts || {});
            selector = options.selector;
            wipeOpt = options.wipe;
            analyzer = wipeOpt.analyzer;
            trackingEnabled = wipeOpt.enabled && !!analyzer;
            autoCompleteOptions = options.autoComplete;
            suggestionCache = {};
            hiddenFieldsProperty = options.hiddenFields.property;
        }
        function highlightSearchTerm(value, searchTerm) {
            if (!options.doHighlight) {
                return value;
            }
            return value.replace(new RegExp("^(?![^&;]+;)(?!<[^<>]*)(" + searchTerm.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "i"), "<strong>$1</strong>");
        }
        function doTrack(logStr, type, doAfterLog) {
            var canTrack = true;
            if (!trackingEnabled) {
                global.trace("Wipe tracking disabled.");
                canTrack = false;
            }
            if (!global.util.AnalyzerCheck.isValidAnalyzer(wipeOpt)) {
                global.error(global.util.AnalyzerCheck.getNoAnalyzerErrorText(), wipeOpt);
                canTrack = false;
            }
            if (!(type in wipeOpt.type)) {
                global.trace("Unknown wipe type: ", type);
                canTrack = false;
            }
            if (!canTrack) {
                if (global.val.isFunction(doAfterLog)) {
                    doAfterLog();
                }
                return;
            }
            var logFun = type === wipeOpt.type.ACTION ? analyzer.logAction : analyzer.logError;
            if (global.val.isFunction(doAfterLog) && type === wipeOpt.type.ACTION) {
                logFun(logStr, {
                    then: doAfterLog
                });
            } else {
                logFun(logStr);
            }
        }
        function getGeolocationRow() {
            var result = doc.createElement("li");
            result.innerText = options.geolocation.text;
            result.dataset.data = JSON.stringify({
                type: options.geolocation.type
            });
            return result;
        }
        function removeSuggestionList() {
            var list = doc.getElementById(selector.suggestionListId);
            if (list) {
                list.remove();
            }
        }
        function removeHiddenField(value, idx, arr) {
            var keys = Object.keys(value), name = keys[0], elements = doc.getElementsByName(name);
            elements.forEach(function(element, idx, listObj) {
                element.remove();
            });
        }
        function removeHiddenFields() {
            if (global.val.isArray(currentHiddenFields)) {
                currentHiddenFields.forEach(removeHiddenField);
            }
        }
        function setHiddenField(value, idx, arr) {
            var field, keys;
            try {
                field = doc.createElement("input");
                field.setAttribute("type", "hidden");
                keys = Object.keys(value);
                field.setAttribute("name", keys[0]);
                field.value = value[keys[0]];
                searchForm.appendChild(field);
            } catch (e) {
                global.trace("Failed to set hidden field", value);
            }
        }
        function setHiddenFields(hiddenFields) {
            if (global.val.isArray(hiddenFields)) {
                currentHiddenFields = hiddenFields;
                currentHiddenFields.forEach(setHiddenField);
            } else {
                global.trace("Array expected, but get: ", hiddenFields);
            }
        }
        function setAreaInputValue(value) {
            areaInput.value = value;
        }
        function onClickSuggesterItem(event) {
            var element = event.currentTarget, data = element.dataset.data;
            try {
                data = JSON.parse(element.dataset.data);
                if (data && data.hasOwnProperty("type") && data.type === options.geolocation.type) {
                    doGeolocationRequest();
                } else {
                    setAreaInputValue(data.na);
                    setHiddenFields(data[hiddenFieldsProperty]);
                    doTrack(wipeOpt.action.suggesterCityClick, wipeOpt.type.ACTION, autoCompleteOptions.autoSubmit ? onSearchFormSubmit : undefined);
                }
                removeSuggestionList();
            } catch (e) {
                global.trace(e);
            }
        }
        function bindSuggestionListEvents(suggestionList) {
            var items = suggestionList.getElementsByTagName("li");
            for (var i = 0; i < items.length; i++) {
                items[i].addEventListener("click", onClickSuggesterItem);
            }
        }
        function buildSuggestionList(data, term) {
            var ul = doc.createElement("ul");
            ul.id = selector.suggestionListId;
            ul.classList.add("autolocation", "autoloc", "autosuggest");
            if (options.addGeolocationRow) {
                ul.appendChild(getGeolocationRow());
            }
            if (!data.hasOwnProperty("std")) {
                global.trace("Failed to build suggestion list. std-Property not available.", data);
                return;
            }
            data.std.forEach(function(cityData, index, arr) {
                var state, li, hiddenFieldCityKeyData = {};
                cityData[hiddenFieldsProperty] = data.hasOwnProperty(hiddenFieldsProperty) ? global.util.JSON.clone(data[hiddenFieldsProperty]) : [];
                hiddenFieldCityKeyData[options.hiddenFields.cityKeyName] = cityData.cokey;
                cityData[hiddenFieldsProperty].push(hiddenFieldCityKeyData);
                if (cityData.hasOwnProperty("state") && cityData.state !== "") {
                    state = doc.createElement("small");
                    state.innerText = cityData.state;
                }
                li = doc.createElement("li");
                li.innerHTML = highlightSearchTerm(cityData.na, term);
                li.dataset.data = JSON.stringify(cityData);
                if (state) {
                    li.insertBefore(state, li.firstChild);
                }
                ul.appendChild(li);
            });
            bindSuggestionListEvents(ul);
            return ul;
        }
        function showSuggestionList(inputTerm) {
            removeSuggestionList();
            try {
                inputParent.append(buildSuggestionList(suggestionCache[inputTerm].data, inputTerm));
            } catch (e) {
                global.trace(e);
            }
        }
        function isCacheLifetimeExceeded(data) {
            return !!(!data.hasOwnProperty("timestamp") || Date.now() - data.timestamp > options.maxCacheTime);
        }
        function addCacheData(inputTerm, data) {
            suggestionCache[inputTerm] = {
                data: data,
                timestamp: Date.now()
            };
        }
        function suggestionInCache(inputTerm) {
            return suggestionCache.hasOwnProperty(inputTerm) && suggestionCache[inputTerm].data.std.length > 0 && !isCacheLifetimeExceeded(suggestionCache[inputTerm]);
        }
        function onGetSuggestionData(inputTerm, data) {
            if (!global.val.isObject(data) || !data.hasOwnProperty("std") || !global.val.isArray(data.std)) {
                global.trace("Unexpected data received for input: '" + inputTerm + "'. data: ", data);
                return;
            }
            if (data.std.length <= 0) {
                console.debug("no suggestion data available");
                return;
            }
            if (!suggestionInCache(inputTerm)) {
                addCacheData(inputTerm, data);
            }
            showSuggestionList(inputTerm);
        }
        function getSuggestions(inputTerm) {
            if (inputTerm === "") {
                return;
            }
            if (suggestionInCache(inputTerm)) {
                onGetSuggestionData(inputTerm, suggestionCache[inputTerm].data);
                return;
            }
            if (global.val.isFunction(autoCompleteOptions.onChangeTerm)) {
                autoCompleteOptions.onChangeTerm.call(self, inputTerm, onGetSuggestionData);
            } else {
                global.trace("No input listener defined. See options.autoComplete.onChangeTerm.");
            }
        }
        function showClearItem() {
            clearItem.classList.remove(options.hideClass);
        }
        function hideClearItem() {
            clearItem.classList.add(options.hideClass);
        }
        function onAreaInputFieldInput(event) {
            try {
                var inputField = event.currentTarget, value = inputField.value;
                removeHiddenFields();
                hideErrorMessage();
                if (value === "") {
                    hideClearItem();
                } else {
                    showClearItem();
                    if (value.length >= autoCompleteOptions.minChars) {
                        clearTimeout(timeout);
                        timeout = setTimeout(function() {
                            getSuggestions(value);
                        }, autoCompleteOptions.delay);
                    }
                }
            } catch (e) {
                global.trace(e);
            }
        }
        function clearAreaInputField() {
            areaInput.value = "";
            hideClearItem();
            removeHiddenFields();
            doTrack(wipeOpt.action.clearInput, wipeOpt.type.ACTION);
        }
        function hideErrorMessage() {
            hintItem.classList.add(options.hideClass);
        }
        function showErrorMessage(msg) {
            removeSuggestionList();
            hintItem.innerHTML = msg;
            hintItem.classList.remove(options.hideClass);
        }
        function onGetReverseGeolocation(data) {
            try {
                if (global.val.isString(data)) {
                    data = JSON.parse(data);
                }
                if (typeof data.status === "undefined" || data.status === null || parseInt(data.status, 10) !== 0) {
                    throw new Error("Response status: " + data.status + " Status text: " + data.statusText);
                }
                hideErrorMessage();
                setAreaInputValue(data.na);
                showClearItem();
                removeHiddenFields();
                setHiddenFields(data.hiddenFields);
            } catch (e) {
                removeHiddenFields();
                showErrorMessage(options.errors.default);
                global.trace(e);
            }
        }
        function onGetCurrentPosition(pos) {
            hideErrorMessage();
            removeSuggestionList();
            doTrack(wipeOpt.action.geolocation.permissionGranted, wipeOpt.type.ACTION);
            var callback = options.geolocation.onGetCurrentPosition, location = pos.toJSON(), result = {
                latitude: location.coords.latitude,
                longitude: location.coords.longitude,
                accuracy: location.coords.accuracy,
                timestamp: location.timestamp
            };
            if (global.val.isFunction(callback)) {
                callback.call(self, result, onGetReverseGeolocation);
            } else {
                global.trace("Function expected, but get: ", callback);
            }
        }
        function onGetCurrentPositionError(err) {
            if (err instanceof GeolocationPositionError) {
                if (err.code === 1) {
                    doTrack(wipeOpt.action.geolocation.permissionDenied, wipeOpt.type.ACTION);
                    showErrorMessage(options.errors.geolocation.PERMISSION_DENIED.msg);
                } else if (err.code === 2) {
                    doTrack(wipeOpt.error.geolocation.positionUnavailable, wipeOpt.type.ERROR);
                    showErrorMessage(options.errors.geolocation.POSITION_UNAVAILABLE.msg);
                }
                if (err.code === 3) {
                    doTrack(wipeOpt.error.geolocation.timeout, wipeOpt.type.ERROR);
                    showErrorMessage(options.errors.geolocation.TIMEOUT.msg);
                }
            }
        }
        function doGeolocationRequest(event) {
            doTrack(event ? wipeOpt.action.geolocation.iconClick : wipeOpt.action.geolocation.suggesterEntryClick, wipeOpt.type.ACTION);
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(onGetCurrentPosition, onGetCurrentPositionError);
            } else {
                global.trace("Geolocation not available");
            }
        }
        function bindBodyEvents() {
            "click contextmenu".split(" ").forEach(function(eventType) {
                doc.body.addEventListener(eventType, removeSuggestionList);
            });
        }
        function submitSearchForm() {
            searchForm.submit();
        }
        function onSearchFormSubmit(event) {
            if (event) {
                event.preventDefault();
            }
            doTrack(wipeOpt.action.sendForm, wipeOpt.type.ACTION, submitSearchForm);
        }
        function bindEvents() {
            try {
                searchForm = doc.getElementById(selector.searchFormId);
                areaInput = doc.getElementById(selector.inputId);
                inputParent = searchForm.querySelector(selector.inputParent);
                clearItem = doc.querySelector(selector.clearItem);
                geoLocationItem = doc.querySelector(selector.locateItem);
                hintItem = doc.getElementById(selector.hintItemId);
                searchForm.addEventListener("submit", onSearchFormSubmit);
                areaInput.addEventListener("input", onAreaInputFieldInput);
                clearItem.addEventListener("click", clearAreaInputField);
                geoLocationItem.addEventListener("click", doGeolocationRequest);
                bindBodyEvents();
            } catch (e) {
                global.trace(e);
            }
        }
        this.bindEvents = bindEvents;
        init(opts);
    }
    namespace.SimpleSearchboxHandler = SimpleSearchboxHandler;
})($oe$, this, document);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, win, doc) {
    var namespace = global.getNamespace("search"), $window = $(win);
    function StickyController(selector, scOptions) {
        var self = this, options, DEFAULTOPTIONS = {
            stickyClass: "sticky",
            fadeOutClass: "searchup",
            inputAreaClass: "inputarea",
            offsetTop: 354,
            autoStart: true,
            interval: 250,
            delta: {
                down: 165,
                up: 70,
                min: 5
            }
        }, $sticker, lastScrollTop = 0, intervalId, didScroll = false;
        function init(selector, scOptions) {
            options = $.extend(true, {}, DEFAULTOPTIONS, scOptions || {});
            $sticker = $(selector);
            if (options.autoStart) {
                self.activate();
            }
        }
        this.activate = function() {
            self.deactivate();
            $window.on("scroll", self.onScroll);
            intervalId = setInterval(self.setStickyMode, options.interval);
        };
        this.onScroll = function() {
            didScroll = true;
        };
        this.deactivate = function() {
            if (global.val.isDefined(intervalId)) {
                clearInterval(intervalId);
            }
            $window.off("scroll", self.onScroll);
        };
        this.setStickyMode = function() {
            var highestMenuItem, pos;
            if (!didScroll) {
                return;
            }
            didScroll = false;
            if (Math.abs(lastScrollTop - $window.scrollTop()) <= options.delta.min) {
                return;
            }
            highestMenuItem = $("." + options.inputAreaClass);
            pos = highestMenuItem.offset();
            if ($window.scrollTop() > pos.top + highestMenuItem.height() && $window.scrollTop() < lastScrollTop) {
                $sticker.addClass(options.stickyClass).removeClass(options.fadeOutClass);
            } else if ($sticker.hasClass(options.stickyClass) && $window.scrollTop() <= options.offsetTop) {
                $sticker.removeClass(options.stickyClass).removeClass(options.fadeOutClass);
            }
            if ($sticker.hasClass(options.stickyClass) && !$sticker.hasClass(options.fadeOutClass) && $window.scrollTop() > lastScrollTop) {
                $sticker.addClass(options.fadeOutClass);
            }
            if (!$sticker.hasClass(options.fadeOutClass) && $window.scrollTop() > options.offsetTop && $window.scrollTop() > lastScrollTop) {
                $sticker.addClass(options.fadeOutClass);
            }
            if ($window.scrollTop() <= options.offsetTop) {
                $sticker.removeClass(options.stickyClass).removeClass(options.fadeOutClass);
            }
            lastScrollTop = $window.scrollTop();
        };
        init(selector, scOptions);
    }
    namespace.StickyController = StickyController;
})($oe$, this, document);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, window, document) {
    var namespace = global.getNamespace("storage");
    function StorageHandler(origin, path, version) {
        var self = this, iframe, iframeReady = false, queue = [], requests = {}, handlerId = 0, url, urlBase = "https://www.dasoertliche.de";
        try {
            url = new URL(origin, urlBase);
            origin = url.origin;
        } catch (e) {
            global.trace("Failed to parse origin", origin);
        }
        function init() {
            if (!self.isAvailable()) {
                throw new Error("Unsupported browser.");
            }
            try {
                if (!iframe) {
                    iframe = document.createElement("iframe");
                    iframe.style.cssText = "width:1px;height:1px;position:absolute;left:-9999px;";
                    document.body.appendChild(iframe);
                    iframe.removeEventListener("load", self._onIframeLoaded, false);
                    window.removeEventListener("message", self._handleResponse, false);
                    iframe.addEventListener("load", self._onIframeLoaded, false);
                    window.addEventListener("message", self._handleResponse, false);
                }
                iframe.src = createUrl(origin, path);
            } catch (e) {}
        }
        this.get = function(key, processId, callback) {
            commit("get", key, processId, null, callback);
        };
        this.set = function(key, processId, val, callback) {
            commit("set", key, processId, val, callback);
        };
        this.remove = function(key, processId, callback) {
            commit("remove", key, processId, null, callback);
        };
        function commit(action, key, processId, val, callback) {
            if (!self.isAvailable()) {
                if (global.val.isFunction(callback)) {
                    callback({
                        id: processId
                    });
                    return;
                }
            }
            var request = {
                key: key,
                val: val,
                action: action,
                id: processId
            }, data = {
                request: request,
                callback: callback
            };
            try {
                if (iframeReady) {
                    sendRequest(data);
                } else {
                    queue.push(data);
                }
                if (!iframe) {
                    init();
                }
            } catch (e) {}
        }
        this.getProcessId = function() {
            return ++handlerId;
        };
        function sendRequest(data) {
            try {
                requests[data.request.id] = data;
                iframe.contentWindow.postMessage(global.util.JSON.toJSON(data.request), origin);
            } catch (e) {}
        }
        this._onIframeLoaded = function() {
            try {
                iframeReady = true;
                if (queue.length) {
                    for (var i = 0, len = queue.length; i < len; i++) {
                        sendRequest(queue[i]);
                    }
                    queue = [];
                }
            } catch (e) {}
        };
        this._handleResponse = function(event) {
            var data;
            try {
                while (event.origin.substr(-1) === "/") {
                    event.origin = event.origin.substr(0, event.origin.length - 1);
                }
                if (event.origin === origin) {
                    data = global.util.JSON.parseJSON(event.data);
                    if (data) {
                        if (requests[data.id] && typeof requests[data.id].callback === "function") {
                            requests[data.id].callback(data);
                        }
                        delete requests[data.id];
                    }
                }
            } catch (e) {}
        };
        function createUrl(origin, path) {
            var slash = origin.lastIndexOf("/") !== origin.length && path.indexOf("/") !== 0 ? "/" : "", url, rndKey = global.util.Tools.getUniqueKey(), paramName = "_sh_rk", et;
            if (window.URL) {
                try {
                    url = new URL(origin + slash + path);
                    url.searchParams.append(paramName, rndKey);
                    return url.href;
                } catch (e) {
                    global.trace("Failed ro create url. origin: " + origin + " path: " + path + " " + paramName + ": " + rndKey);
                }
            } else {
                et = path.indexOf("?") === -1 ? "?" : "&";
                return origin + slash + path + et + paramName + "=" + rndKey;
            }
        }
        this.isAvailable = function() {
            try {
                return window.postMessage && window.localStorage;
            } catch (e) {
                return false;
            }
        };
    }
    namespace.StorageHandler = StorageHandler;
})($oe$, this, document);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global) {
    var namespace = global.getNamespace("search");
    function SearchHistory(config) {
        var self = this, version = "7.27", options, storageHandler, WEB_STORAGE_KEY = "_DasOertliche_Suchhistorie_", defaultOptions = {
            maxStorageItemSize: 1e3,
            maxKwLength: 80,
            maxCiLength: 80,
            maxSeKwLength: 80,
            maxSeCiLength: 80,
            topCount: 100,
            topCountLimit: 2,
            ageCount: 100,
            cityCount: 30,
            categoryCount: 20,
            excludeCategory: [],
            origin: "//www.dasoertliche.de",
            path: "js/oe.storage.html"
        }, defaultSearchHistoryItem = {
            kw: "",
            ci: "",
            arkey: "",
            cat: [],
            ts: null,
            count: 1
        }, callbackStack = [], status = {
            ok: "ok",
            disabled: "disabled",
            notAvailable: "not available",
            failed: "failed",
            noKw: "no kw"
        }, enabled = false, globalUtilJSON = global.util.JSON, globalVal = global.val, globalLog = global.log;
        init();
        function init() {
            try {
                options = $.extend(true, {}, defaultOptions, config || {});
                storageHandler = new global.storage.StorageHandler(options.origin, options.path, version);
            } catch (ex) {
                global.trace(ex);
            }
        }
        this.get = function(callback, type) {
            var internalCallback, processId;
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            type = typeof type !== "undefined" ? type : "";
            try {
                switch (type.toUpperCase()) {
                  case "SEKW":
                    internalCallback = self._onStorageHandlerResponseSEKeyword;
                    break;

                  case "SECI":
                    internalCallback = self._onStorageHandlerResponseSECity;
                    break;

                  default:
                    internalCallback = self._onStorageHandlerResponse;
                    break;
                }
                processId = storageHandler.getProcessId();
                callbackStack.push({
                    id: processId,
                    callback: callback
                });
                storageHandler.get(WEB_STORAGE_KEY, processId, internalCallback);
            } catch (ex) {
                globalLog(ex);
            }
        };
        this._onStorageHandlerResponseSEKeyword = function(data) {
            var searchHistory, callbackProps, tmpHistory = [], i, callbackHistory = {
                history: {
                    keys: [ "kw", "arkey", "count" ],
                    values: []
                },
                cat: {
                    keys: [ "id", "share" ],
                    values: []
                }
            };
            try {
                searchHistory = extractSearchHistory(data);
                if (searchHistory) {
                    if (searchHistory.seHistory) {
                        tmpHistory = searchHistory.seHistory;
                    } else if (searchHistory.history) {
                        tmpHistory = searchHistory.history;
                    }
                    i = 0;
                    $.each(tmpHistory, function(key, item) {
                        if (i > options.topCount + options.ageCount) {
                            return false;
                        }
                        callbackHistory.history.values.push([ item.kw, item.arkey, item.count ]);
                        i++;
                    });
                    if (searchHistory.cat) {
                        i = 0;
                        $.each(searchHistory.cat, function(key, item) {
                            if (i >= options.categoryCount) {
                                return false;
                            }
                            callbackHistory.cat.values.push([ item.id, item.share ]);
                            i++;
                        });
                    }
                }
                callbackProps = getCallback(data.id);
                if (globalVal.isObject(callbackProps) && callbackProps.callback) {
                    callbackProps.callback(callbackHistory, data);
                }
            } catch (e) {
                globalLog("_onStorageHandlerResponseSEKeyword: " + e);
            }
        };
        this._onStorageHandlerResponseSECity = function(data) {
            var searchHistory, callbackProps, callbackHistory = {
                ci: {
                    keys: [ "arkey", "count" ],
                    values: []
                }
            }, cityCount;
            try {
                searchHistory = extractSearchHistory(data);
                if (searchHistory) {
                    if (searchHistory.ci) {
                        cityCount = 0;
                        $.each(searchHistory.ci, function(key, item) {
                            if (cityCount >= options.cityCount) {
                                return false;
                            }
                            callbackHistory.ci.values.push([ item.arkey, item.count ]);
                            cityCount++;
                        });
                    }
                }
                callbackProps = getCallback(data.id);
                if (globalVal.isObject(callbackProps) && callbackProps.callback) {
                    callbackProps.callback(callbackHistory, data);
                }
            } catch (e) {
                globalLog("_onStorageHandlerResponseSECity: " + e);
            }
        };
        this.set = function(data, callback, external) {
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            if (typeof storageHandler === "undefined") {
                return;
            }
            try {
                if (globalVal.isString(data)) {
                    data = globalUtilJSON.parseJSON(data);
                }
                if (!globalVal.isObject(data)) {
                    throw new Error("Parse Exception. Object required.");
                }
                if (typeof data.history === "undefined") {
                    throw new Error("No history property available.");
                }
                if (data.history.length > options.maxStorageItemSize) {
                    data.history = resetItemSize(data.history, options.maxStorageItemSize);
                }
                if (typeof data.version === "undefined") {
                    data.version = version;
                }
                data.history.sort(sortByTimestamp);
                data.seHistory = createSearchEngineHistory(data.history, options.topCountLimit);
                var processId = storageHandler.getProcessId();
                callbackStack.push({
                    id: processId,
                    callback: callback
                });
                storageHandler.set(WEB_STORAGE_KEY, processId, data, self._onStorageHandlerResponse);
            } catch (ex) {
                globalLog(ex);
            }
        };
        function createSearchEngineHistory(history, topCountLimit) {
            var seHistory = [], tmpHistory = $.extend([], history);
            try {
                tmpHistory.sort(sortByCount);
                for (var i = 0; i < tmpHistory.length; i++) {
                    if (i === options.topCount || tmpHistory[0].count < topCountLimit) {
                        break;
                    }
                    seHistory.push(tmpHistory.shift());
                }
                tmpHistory.sort(sortByTimestamp);
                while (tmpHistory.length > 0) {
                    if (seHistory.length >= options.ageCount + options.topCount) {
                        break;
                    }
                    seHistory.push(tmpHistory.shift());
                }
                seHistory.sort(sortByTimestamp);
                if (options.maxSeKwLength < options.maxKwLength || options.maxSeCiLength < options.maxCiLength) {
                    $.each(seHistory, function(id, item) {
                        item.ci = item.ci.substring(0, options.maxSeCiLength);
                        item.kw = item.kw.substring(0, options.maxSeKwLength);
                    });
                }
            } catch (e) {
                globalLog("SearchHistory.createSearchEngineHistory: " + e);
                seHistory = tmpHistory;
            }
            return seHistory;
        }
        this._onStorageHandlerResponse = function(data) {
            var callbackProps, callbackParam;
            try {
                if (!globalVal.isObject(data)) {
                    return;
                }
                switch (data.action) {
                  case "get":
                    callbackParam = extractSearchHistory(data);
                    break;

                  case "set":
                    callbackParam = {
                        status: data.status
                    };
                    break;

                  case "delete":
                  case "remove":
                    break;
                }
            } catch (e) {
                globalLog(e);
            } finally {
                callbackProps = getCallback(data.id);
                if (globalVal.isObject(callbackProps) && callbackProps.callback) {
                    callbackProps.callback(callbackParam, data);
                }
            }
        };
        function extractSearchHistory(data) {
            var searchHistory;
            try {
                if (globalVal.isDefined(data) && data.hasOwnProperty("value")) {
                    searchHistory = globalUtilJSON.parseJSON(data.value);
                }
            } catch (e) {
                globalLog(e);
            }
            return searchHistory;
        }
        this.add = function(data, callback) {
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            try {
                if (globalVal.isString(data)) {
                    data = globalUtilJSON.parseJSON(data);
                }
                var processId = storageHandler.getProcessId();
                callbackStack.push({
                    id: processId,
                    callback: callback,
                    addData: data
                });
                storageHandler.get(WEB_STORAGE_KEY, processId, self._onGet4Add);
            } catch (ex) {
                globalLog(ex);
            }
        };
        this._onGet4Add = function(data) {
            var callbackProps, searchHistory;
            try {
                callbackProps = getCallback(data.id);
                searchHistory = extractSearchHistory(data);
                if (!callbackProps.addData.history && !callbackProps.addData.cat) {
                    if (globalVal.isFunction(callbackProps.callback)) {
                        callbackProps.callback({
                            status: status.failed,
                            message: "Required properties missing."
                        });
                        return;
                    }
                }
                if (!searchHistory) {
                    callbackProps.addData.version = version;
                    self.set(callbackProps.addData, callbackProps.callback);
                    return;
                }
                if (!searchHistory.history) {
                    searchHistory.history = {};
                }
                $.each(callbackProps.addData.history, function(didx, addItem) {
                    var contains = false;
                    $.each(searchHistory.history, function(idx, currentItem) {
                        if (currentItem.kw && addItem.kw && currentItem.kw.toLowerCase() === addItem.kw.toLowerCase() && currentItem.arkey === addItem.arkey) {
                            addItem.count = currentItem.count ? currentItem.count : addItem.count ? addItem.count : 0;
                            currentItem = $.extend(currentItem, addItem);
                            contains = true;
                            return false;
                        }
                    });
                    if (!contains) {
                        searchHistory.history.push(addItem);
                    }
                });
                self.set(searchHistory, callbackProps.callback);
            } catch (e) {
                globalLog("Error. _onGet4Add: " + e);
            }
        };
        this.addSearch = function(kw, ci, areaKey, cat, catMatch, callback, update) {
            var processId;
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            if (!isAvailable()) {
                callback({
                    status: status.notAvailable
                });
                return;
            }
            if (kw.trim() === "") {
                callback({
                    status: status.noKw
                });
                return;
            }
            update = typeof update !== "undefined" ? update : false;
            processId = storageHandler.getProcessId();
            callbackStack.push({
                callback: callback,
                kw: kw.substring(0, options.maxKwLength),
                ci: ci.substring(0, options.maxCiLength),
                cat: cat,
                catMatch: catMatch,
                update: update,
                areaKey: areaKey,
                id: processId
            });
            storageHandler.get(WEB_STORAGE_KEY, processId, self._onGet4AddSearch);
        };
        this._onGet4AddSearch = function(data) {
            var item, searchHistory, update = false, callbackProps, callback, cats;
            try {
                callbackProps = getCallback(data.id);
                callback = callbackProps.callback;
                item = $.extend(true, {}, defaultSearchHistoryItem);
                item.ts = createCurrentTimeStamp();
                cats = expandCategories(callbackProps.cat);
                item = $.extend(item, {
                    kw: callbackProps.kw,
                    ci: callbackProps.ci,
                    cat: cats,
                    arkey: callbackProps.areaKey
                });
                searchHistory = extractSearchHistory(data);
                if (!searchHistory) {
                    searchHistory = {
                        cat: [],
                        ci: [],
                        version: version
                    };
                }
                searchHistory.cat = createTopCategoryList(searchHistory.cat, item.cat, searchHistory.history);
                searchHistory.ci = createTopCityList(searchHistory.ci, item);
                if (searchHistory.history) {
                    $.each(searchHistory.history, function(idx, currentItem) {
                        if (currentItem.kw && item.kw && currentItem.kw.toLowerCase() === item.kw.toLowerCase() && currentItem.arkey === item.arkey) {
                            item.count = currentItem.count ? currentItem.count + 1 : 1;
                            currentItem = $.extend(currentItem, item);
                            update = true;
                            return false;
                        }
                    });
                    if (!update) {
                        if (searchHistory.history.length >= options.maxStorageItemSize) {
                            searchHistory.history = resetItemSize(searchHistory.history, options.maxStorageItemSize - 1);
                        }
                        searchHistory.history.unshift(item);
                    }
                } else {
                    searchHistory.history = [ item ];
                }
                self.set(searchHistory, callback);
            } catch (ex) {
                globalLog(ex);
                if (globalVal.isFunction(callback)) {
                    callback({
                        status: status.failed
                    });
                }
            }
        };
        function expandCategories(catVal) {
            var catParts1, catParts2, catName = "", catNo = "", hitCount = "", cats = [], categories;
            function isBlacklistCategory(catNo) {
                for (var j = 0; j < options.excludeCategory.length; j++) {
                    if (options.excludeCategory[j].key === catNo) {
                        return true;
                    }
                }
                return false;
            }
            if (globalVal.isArray(catVal)) {
                cats = catVal;
                for (var i = 0; i < cats.length; i++) {
                    if (isBlacklistCategory(cats[i])) {
                        cats.splice(i, 1);
                    }
                }
            } else if (globalVal.isString(catVal)) {
                categories = catVal.split(";");
                try {
                    $.each(categories, function(key, val) {
                        catParts1 = val.split("|");
                        if (catParts1.length > 1) {
                            catParts2 = catParts1[1].split("=");
                            catName = catParts1[0];
                            if (catParts2.length >= 1) {
                                catNo = catParts2[0];
                                if (!isBlacklistCategory(catNo)) {
                                    cats.push(catNo);
                                }
                            }
                            if (catParts2.length > 1) {
                                hitCount = catParts2[1];
                            }
                        }
                    });
                } catch (e) {
                    globalLog(e);
                }
            }
            return cats.length === 1 ? cats : [];
        }
        function createTopCategoryList(categories, addCategories, history) {
            if (!globalVal.isArray(addCategories) || addCategories.length === 0) {
                return categories;
            }
            var list = categories ? categories : [], update = false, maxCount = 1;
            try {
                $.each(addCategories, function(cid, cat) {
                    update = false;
                    $.each(list, function(idx, listItem) {
                        if (listItem.id === cat) {
                            listItem.count += 1;
                            update = true;
                            return false;
                        }
                    });
                    if (!update) {
                        list.push({
                            id: cat,
                            count: 1
                        });
                    }
                });
                list.sort(sortByCount);
                if (list.length > 0) {
                    maxCount = maxCount < list[0].count ? list[0].count : maxCount;
                }
                $.each(list, function(idx, listItem) {
                    listItem.share = (listItem.count / maxCount).toFixed(1);
                });
            } catch (e) {
                globalLog(e);
                list = categories;
            }
            return list;
        }
        function createTopCityList(cities, item) {
            if (!globalVal.isObject(item)) {
                return cities;
            }
            var list = cities ? cities : [], update = false;
            try {
                update = false;
                $.each(list, function(idx, listItem) {
                    if (listItem.arkey === item.arkey) {
                        listItem.ci = item.ci && item.ci !== "" ? item.ci : listItem.ci;
                        listItem.count += 1;
                        update = true;
                        return false;
                    }
                });
                if (!update) {
                    list.push({
                        arkey: item.arkey,
                        ci: item.ci,
                        count: 1
                    });
                }
                list.sort(sortByCount);
            } catch (e) {
                globalLog(e);
                list = cities;
            }
            return list;
        }
        this.remove = function(callback) {
            if (isAvailable()) {
                var processId = storageHandler.getProcessId();
                if (globalVal.isDefined(callback)) {
                    callbackStack.push({
                        callback: callback,
                        id: processId
                    });
                }
                storageHandler.remove(WEB_STORAGE_KEY, processId, callback);
            }
        };
        this.enable = function() {
            enabled = true;
        };
        this.disable = function(removeCallback) {
            enabled = false;
            this.remove(removeCallback);
        };
        this.isEnabled = function() {
            return enabled;
        };
        this.removeKeywordFromSearchHistory = function(kw, callback) {
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            if (!isAvailable()) {
                callback({
                    status: status.notAvailable
                });
                return;
            }
            var processId = storageHandler.getProcessId();
            kw = typeof name === "string" ? kw.trim() : kw;
            callbackStack.push({
                callback: callback,
                kw: kw,
                id: processId
            });
            storageHandler.get(WEB_STORAGE_KEY, processId, self._onGet4RemoveKeywordFromSearchHistory);
        };
        this._onGet4RemoveKeywordFromSearchHistory = function(data) {
            var callbackProps, searchHistory, i, currentItem;
            try {
                callbackProps = getCallback(data.id);
                searchHistory = extractSearchHistory(data);
                if (!searchHistory || !searchHistory.history) {
                    callbackProps.callback({
                        status: status.ok
                    });
                    return;
                }
                if (searchHistory && searchHistory.history) {
                    for (i = 0; i < searchHistory.history.length; i++) {
                        currentItem = searchHistory.history[i];
                        if (global.str.equalsIgnoreCase(callbackProps.kw, currentItem.kw)) {
                            searchHistory.history.splice(i, 1);
                            i--;
                        }
                    }
                }
                self.set(searchHistory, callbackProps.callback);
            } catch (e) {
                globalLog("Error. _onGet4RemoveKeywordFromSearchHistory: " + e);
            }
        };
        this.removeRegionFromSearchHistory = function(name, arKey, callback) {
            if (!self.isEnabled()) {
                callback.call(self, {
                    status: status.disabled
                });
                return;
            }
            if (!isAvailable()) {
                callback({
                    status: status.notAvailable
                });
                return;
            }
            var processId = storageHandler.getProcessId();
            name = typeof name === "string" ? name.trim() : name;
            arKey = typeof arKey === "string" ? arKey.trim() : arKey;
            callbackStack.push({
                callback: callback,
                name: name,
                areaKey: arKey,
                id: processId
            });
            storageHandler.get(WEB_STORAGE_KEY, processId, self._onGet4RemoveRegionFromSearchHistory);
        };
        this._onGet4RemoveRegionFromSearchHistory = function(data) {
            var callbackProps, searchHistory, currentItem, name, areaKey;
            function removeItems(list, name, key) {
                for (var i = 0; i < list.length; i++) {
                    currentItem = list[i];
                    if (key && name && currentItem.arkey === key && global.str.equalsIgnoreCase(currentItem.ci, name)) {
                        list.splice(i, 1);
                        i--;
                    } else if (key && !name && currentItem.arkey === key) {
                        list.splice(i, 1);
                        i--;
                    } else if (!key && name && global.str.equalsIgnoreCase(currentItem.ci, name)) {
                        list.splice(i, 1);
                        i--;
                    } else if (global.str.equalsIgnoreCase(key, "de") && currentItem.arkey === "") {
                        list.splice(i, 1);
                        i--;
                    }
                }
            }
            try {
                callbackProps = getCallback(data.id);
                searchHistory = extractSearchHistory(data);
                if (!searchHistory || !searchHistory.history) {
                    callbackProps.callback({
                        status: status.ok
                    });
                    return;
                }
                name = callbackProps.name;
                areaKey = callbackProps.areaKey;
                if (searchHistory && searchHistory.history) {
                    removeItems(searchHistory.history, name, areaKey);
                }
                if (searchHistory && searchHistory.ci) {
                    removeItems(searchHistory.ci, name, areaKey);
                }
                self.set(searchHistory, callbackProps.callback);
            } catch (e) {
                globalLog("Error. _onGet4RemoveRegionFromSearchHistory: " + e);
            }
        };
        function getCallback(id) {
            var obj;
            try {
                for (var i = 0; i < callbackStack.length; i++) {
                    obj = callbackStack[i];
                    if (obj.id === id) {
                        callbackStack.splice(i, 1);
                        return obj;
                    }
                }
            } catch (e) {
                globalLog("getCallback: " + e);
            }
        }
        function isAvailable() {
            return storageHandler.isAvailable();
        }
        function createCurrentTimeStamp() {
            var date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), date.getDay(), date.getHours(), date.getMinutes(), 0).getTime() / 1e3;
        }
        function sortByTimestamp(a, b) {
            try {
                return b.ts - a.ts;
            } catch (ex) {
                globalLog("Failed to sort by timestamp. " + ex);
            }
        }
        function sortByCount(a, b) {
            try {
                return b.count - a.count;
            } catch (ex) {
                globalLog("Failed to sort by timestamp. " + ex);
            }
        }
        function resetItemSize(history, maxVal) {
            try {
                if (!globalVal.isArray(history)) {
                    throw new Error("Array required.");
                }
                globalLog("history-size: " + history.length);
                if (history.length <= maxVal) {
                    return history;
                }
                history.sort(sortByTimestamp);
                globalLog("Maximum searchhistory length of " + options.maxStorageItemSize + " exceeded. Reduce item sice.");
                return history.slice(0, maxVal);
            } catch (ex) {
                globalLog("resetItemSize failed. " + ex);
            }
        }
    }
    namespace.SearchHistory = SearchHistory;
})($oe$);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global) {
    var namespace = global.getNamespace("search");
    function RadiusSearchHandler(config) {
        var self = this, slider, DEFAULT_OPTIONS = {
            containerId: "distance",
            layerId: "distancelayer",
            layerClass: "distance_layer",
            closeButton: {
                Id: "distancelayerbtn",
                class: "btn_close",
                title: "schlie&szlig;en",
                href: "#"
            },
            checkboxId: "umkreis_umkreis",
            outputId: "outputkm",
            checkboxDefaultLabelText: "Im Umkreis: ",
            checkboxLabelText: "Im Umkreis: ",
            layerSelectorId: "umkreis_switch",
            similarStreetId: "adv_aehnliche_suche2",
            scala: {
                values: [ 1, 10, 20, 30, 40, 50 ],
                postfix: "km"
            },
            valueFieldId: "umkreis_umkreis",
            sliderId: "slider",
            values: {
                min: 1,
                max: 50,
                value: 5,
                step: 1
            },
            "z-index": 100,
            handleClass: "rangeslider__handle",
            onSlide: undefined,
            onSlideEnd: undefined
        }, options, layer, $checkbox, lastSliderValue = -1;
        function init(config) {
            try {
                options = global.obj.deepMerge(DEFAULT_OPTIONS, config || {});
                options.values.value = checkRadius(options.values.value);
                initInlineSlider();
            } catch (e) {
                global.log("Init RadiusSearchHandler failed: " + e);
            }
        }
        function initInlineSlider() {
            var sliderParent;
            sliderParent = $("#" + options.layerId);
            if (sliderParent.length <= 0) {
                return;
            }
            sliderParent.html(getSliderContent());
            appendSlider();
            $("." + options.handleClass).append($("<i>").attr("class", "icon-grip"));
        }
        function getSliderContent() {
            return $("<span>").attr("class", "head").html("Umkreissuche:").add(createSlider()).add($("<input>").attr({
                id: options.valueFieldId,
                name: "radius",
                type: "hidden",
                value: options.values.value
            })).add($("<span>").attr({
                id: "outputkm"
            }).html(options.values.value + "km"));
        }
        function checkRadius(radius) {
            radius = parseInt(radius, 10);
            if (radius < options.values.min) {
                radius = options.values.min;
            } else if (radius > options.values.max) {
                radius = options.values.max;
            }
            return radius;
        }
        function createSlider() {
            return $("<input>").attr({
                id: options.sliderId,
                type: "range",
                "aria-label": "Kilometer-Regler",
                "data-rangeslider": "",
                value: self.getRadius(),
                step: options.values.step,
                max: options.values.max,
                min: options.values.min
            });
        }
        function createLayer() {
            var scala;
            layer = $("<div>").attr({
                id: options.layerId,
                class: options.layerClass
            }).css({
                "z-index": options["z-index"]
            }).append($("<h4>").html("Umkreis festlegen").append($("<a>").attr(options.closeButton).on("click", function() {
                self.hide();
            }))).append(createSlider());
            scala = $("<div>").attr({
                class: "fgrs",
                unselectable: "on"
            }).append($("<span>").attr({
                class: "flleft"
            }).html("1km")).append($("<span>").attr({
                id: options.outputId
            })).append($("<span>").attr({
                class: "flright"
            }).html("50km"));
            disableSelection(scala);
            $(layer).append(scala);
            return layer;
        }
        function disableSelection(elm) {
            $(elm).each(function() {
                if (global.val.isDefined(this.onselectstart)) {
                    this.onselectstart = function() {
                        return false;
                    };
                } else if (global.val.isDefined(this.style.MozUserSelect)) {
                    this.style.MozUserSelect = "none";
                } else {
                    this.onmousedown = function() {
                        return false;
                    };
                }
            });
        }
        function appendSlider() {
            slider = $("#" + options.sliderId).rangeslider({
                polyfill: false,
                onInit: function() {
                    lastSliderValue = self.getRadius();
                },
                onSlide: function(position, value) {
                    setRadius(value);
                    if (global.val.isFunction(options.onSlide)) {
                        options.onSlide.call(this, value, position);
                    }
                },
                onSlideEnd: function(position, value) {
                    if (global.val.isFunction(options.onSlideEnd)) {
                        options.onSlideEnd.call(this, value, lastSliderValue, position);
                    }
                    lastSliderValue = value;
                }
            });
        }
        this.destroyRangeSlider = function() {
            if (slider) {
                slider.rangeslider("destroy");
                slider = undefined;
            }
        };
        this.show = function() {
            if (self.isVisible()) {
                return;
            }
            self.disableStreetCheckbox();
            $("#" + options.containerId).append(createLayer());
            appendSlider();
        };
        this.hide = function() {
            self.destroyRangeSlider();
            if (layer) {
                layer.remove();
            }
            if (!$checkbox.prop("checked")) {
                self.enableStreetCheckbox();
            }
        };
        this.isVisible = function() {
            return $("#" + options.layerId).length > 0;
        };
        this.getRadius = function() {
            return parseInt($("#" + options.valueFieldId).val(), 10) || options.values.value;
        };
        function setRadius(internalValue) {
            $("#" + options.valueFieldId).val(internalValue).trigger("change");
            $("#" + options.outputId).html(internalValue + options.scala.postfix);
        }
        this.disableStreetCheckbox = function() {
            $("#" + options.similarStreetId).prop({
                checked: false,
                disabled: true
            });
            $("label[for='" + options.similarStreetId + "']").addClass("lbl_disabled");
        };
        this.enableStreetCheckbox = function() {
            $("#" + options.similarStreetId).prop("disabled", false);
            $("label[for='" + options.similarStreetId + "']").removeClass("lbl_disabled");
        };
        init(config);
    }
    namespace.RadiusSearchHandler = RadiusSearchHandler;
})($oe$);